export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTimeISO: { input: string; output: string; }
  GqlJSON: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

/** Queryable models for autocomplete options */
export enum AutocompleteModel {
  Availability = 'Availability',
  Client = 'Client',
  CourseName = 'CourseName',
  EcologicalFunctionType = 'EcologicalFunctionType',
  Fieldworker = 'Fieldworker',
  ObservationType = 'ObservationType',
  PlannerAreaHavingVisits = 'PlannerAreaHavingVisits',
  PlannerAreasPlannable = 'PlannerAreasPlannable',
  Project = 'Project',
  ProjectExportFileOptions = 'ProjectExportFileOptions',
  ProjectStatus = 'ProjectStatus',
  Protocol = 'Protocol',
  ResearchType = 'ResearchType',
  Species = 'Species',
  TenantRole = 'TenantRole'
}

/** Permissions this user has within the client */
export enum ClientPermission {
  ClientAdmin = 'CLIENT_ADMIN',
  ClientViewer = 'CLIENT_VIEWER'
}

export type ConditionalAction = {
  __typename: 'ConditionalAction';
  allowed: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type EcologicalFunctionFieldResolver_CreatedByUserPayload = {
  __typename: 'EcologicalFunctionFieldResolver_createdByUserPayload';
  data?: Maybe<GqlUser>;
  error?: Maybe<GqlFieldError>;
};

export type GqlAddressLocation = {
  __typename: 'GqlAddressLocation';
  fullAddress: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  shortAddress: Scalars['String']['output'];
};

export type GqlAppConfig = {
  __typename: 'GqlAppConfig';
  androidMinBuild: Scalars['Float']['output'];
  androidRecommendedBuild: Scalars['Float']['output'];
  androidRecommendedVersion: Scalars['String']['output'];
  androidUpdateUrl: Scalars['String']['output'];
  iosMinBuild: Scalars['Float']['output'];
  iosRecommendedBuild: Scalars['Float']['output'];
  iosRecommendedVersion: Scalars['String']['output'];
  iosUpdateUrl: Scalars['String']['output'];
};

export type GqlAppEventBatchCreateData = {
  events: Scalars['GqlJSON']['input'];
  id: Scalars['ID']['input'];
};

export type GqlAutocompleteOption = {
  __typename: 'GqlAutocompleteOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GqlAutocompleteResult = {
  __typename: 'GqlAutocompleteResult';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlAvailability = {
  __typename: 'GqlAvailability';
  availabilityCategoryId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minimumAvailability: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export type GqlAvailabilityCategory = {
  __typename: 'GqlAvailabilityCategory';
  availabilities: Array<GqlAvailability>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  period: GqlAvailabilityPeriod;
};

export type GqlAvailabilityPeriod = {
  __typename: 'GqlAvailabilityPeriod';
  endAt: Scalars['DateTimeISO']['output'];
  startAt: Scalars['DateTimeISO']['output'];
};

export type GqlClient = {
  __typename: 'GqlClient';
  address: Scalars['String']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAllMapEditorLayersDefaultVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  profilePicture?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
  type: GqlClientType;
  website?: Maybe<Scalars['String']['output']>;
};

export type GqlClientCreateInput = {
  address: Scalars['String']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  isAllMapEditorLayersDefaultVisible: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  profilePicture?: InputMaybe<Scalars['ID']['input']>;
  type: GqlClientType;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type GqlClientDeleteInput = {
  clientId: Scalars['ID']['input'];
};

export type GqlClientGetAllParams = {
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlClientGetAllPayload = {
  __typename: 'GqlClientGetAllPayload';
  data: Array<GqlClient>;
  queryInfo: GqlQueryInfo;
};

export type GqlClientGetAutocompleteOptionsParams = {
  q?: InputMaybe<Scalars['String']['input']>;
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlClientGetAutocompleteOptionsPayload = {
  __typename: 'GqlClientGetAutocompleteOptionsPayload';
  data: Array<GqlAutocompleteOption>;
  selectedData: Array<GqlAutocompleteOption>;
};

export type GqlClientRole = {
  __typename: 'GqlClientRole';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<ClientPermission>;
};

/** Client type */
export enum GqlClientType {
  Organisation = 'Organisation',
  Private = 'Private'
}

export type GqlClientUpdateInput = {
  address: Scalars['String']['input'];
  clientId: Scalars['ID']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  isAllMapEditorLayersDefaultVisible: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  profilePicture?: InputMaybe<Scalars['ID']['input']>;
  type: GqlClientType;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type GqlClientUser = {
  __typename: 'GqlClientUser';
  client: GqlClient;
  clientId: Scalars['ID']['output'];
  clientRole?: Maybe<GqlClientRole>;
  id: Scalars['ID']['output'];
  roleId: Scalars['ID']['output'];
  user: GqlUser;
  userId: Scalars['ID']['output'];
};

export type GqlClientUserDeleteInput = {
  clientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GqlClientUserGetAllClientsParams = {
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlClientUserGetAllPayload = {
  __typename: 'GqlClientUserGetAllPayload';
  data: Array<GqlClientUser>;
  queryInfo: GqlQueryInfo;
};

export type GqlClientUserGetAllUsersParams = {
  clientId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlClientUserInviteInput = {
  clientId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};

export type GqlCostSpec = GqlSpeciesResearchCostSpec;

export type GqlCostSpecProtocol = {
  __typename: 'GqlCostSpecProtocol';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  total: Scalars['String']['output'];
  visits: Array<GqlCostSpecVisit>;
};

export type GqlCostSpecVisit = {
  __typename: 'GqlCostSpecVisit';
  combinationRound: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  minDuration: Scalars['String']['output'];
  number: Scalars['Float']['output'];
  pricePerHour: Scalars['String']['output'];
  total: Scalars['String']['output'];
  totalIncludingTravel: Scalars['String']['output'];
};

export type GqlCourse = {
  __typename: 'GqlCourse';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GqlCourseAddToUserInput = {
  courseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GqlCourseCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type GqlCourseCreatePayload = {
  __typename: 'GqlCourseCreatePayload';
  course: GqlCourse;
};

export type GqlCourseDeleteInput = {
  courseId: Scalars['ID']['input'];
};

export type GqlCourseDeletePayload = {
  __typename: 'GqlCourseDeletePayload';
  success: Scalars['Boolean']['output'];
};

export type GqlCourseGetAllParams = {
  excludeAssignedToProtocolId?: InputMaybe<Scalars['String']['input']>;
  excludeAssignedToUserId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCourseGetAllPayload = {
  __typename: 'GqlCourseGetAllPayload';
  data: Array<GqlCourse>;
  queryInfo: GqlQueryInfo;
};

export type GqlCourseSelectOption = {
  __typename: 'GqlCourseSelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlCourseSelectOptionsPayload = {
  __typename: 'GqlCourseSelectOptionsPayload';
  data: Array<GqlCourseSelectOption>;
};

export type GqlCourseUpdateInput = {
  courseId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type GqlCourseUpdatePayload = {
  __typename: 'GqlCourseUpdatePayload';
  course: GqlCourse;
};

export type GqlDashboardClientUserClientList = {
  __typename: 'GqlDashboardClientUserClientList';
  clients: GqlClientUserGetAllPayload;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type GqlDashboardComponent = GqlDashboardClientUserClientList | GqlDashboardFieldworkerAvailabilityRequired | GqlDashboardFieldworkerLatestFeedback | GqlDashboardFieldworkerNextDays | GqlDashboardFieldworkerNextShift | GqlDashboardFieldworkerOnboarding | GqlDashboardProjectUserProjectList;

export type GqlDashboardFieldworkerAvailabilityRequired = {
  __typename: 'GqlDashboardFieldworkerAvailabilityRequired';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type GqlDashboardFieldworkerLatestFeedback = {
  __typename: 'GqlDashboardFieldworkerLatestFeedback';
  id: Scalars['ID']['output'];
  reportsWithFeedback: Array<GqlPlannerVisitV2WorkerReport>;
  type: Scalars['String']['output'];
};

export type GqlDashboardFieldworkerNextDays = {
  __typename: 'GqlDashboardFieldworkerNextDays';
  days: Array<GqlFieldworkerCalendarDayEvents>;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type GqlDashboardFieldworkerNextShift = {
  __typename: 'GqlDashboardFieldworkerNextShift';
  id: Scalars['ID']['output'];
  plannerShift: GqlPlannerV2ShiftsGetAll;
  type: Scalars['String']['output'];
};

export type GqlDashboardFieldworkerOnboarding = {
  __typename: 'GqlDashboardFieldworkerOnboarding';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type GqlDashboardProjectUserProjectList = {
  __typename: 'GqlDashboardProjectUserProjectList';
  id: Scalars['ID']['output'];
  projects: GqlProjectUserGetAllPayload;
  type: Scalars['String']['output'];
};

export type GqlDeliverableMap = {
  __typename: 'GqlDeliverableMap';
  features: Array<GqlMapEditorFeature>;
  title: Scalars['String']['output'];
};

export type GqlDeliverableTable = {
  __typename: 'GqlDeliverableTable';
  columns: Array<GqlDeliverableTableColumn>;
  rows: Array<GqlDeliverableTableRow>;
  title: Scalars['String']['output'];
};

export type GqlDeliverableTableColumn = {
  __typename: 'GqlDeliverableTableColumn';
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GqlDeliverableTableRow = {
  __typename: 'GqlDeliverableTableRow';
  columns: Array<GqlDeliverableTableRowColumn>;
  index: Scalars['Int']['output'];
  link?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['ID']['output'];
};

export type GqlDeliverableTableRowColumn = {
  __typename: 'GqlDeliverableTableRowColumn';
  colSpan?: Maybe<Scalars['Int']['output']>;
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** What kind of device the user is using */
export enum GqlDeviceType {
  Android = 'ANDROID',
  Browser = 'BROWSER',
  Ios = 'IOS'
}

export type GqlEcologicalFunction = {
  __typename: 'GqlEcologicalFunction';
  answers?: Maybe<Scalars['GqlJSON']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdById: GqlEcologicalFunction_CreatedByIdPayload;
  createdByUser: EcologicalFunctionFieldResolver_CreatedByUserPayload;
  ecologicalFunctionTypeId: Scalars['String']['output'];
  feature: GqlMapEditorFeature;
  featureId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  medias: Array<GqlMedia>;
  observations: Array<GqlObservation>;
  plannerVisitId?: Maybe<Scalars['String']['output']>;
  preciseLocation?: Maybe<Scalars['GqlJSON']['output']>;
  projectId: Scalars['String']['output'];
  reportId?: Maybe<Scalars['String']['output']>;
  researchType: GqlSettingsResearchType;
  researchTypeId: Scalars['ID']['output'];
  species: GqlSettingsSpecies;
  speciesList: Array<GqlSettingsSpecies>;
  type: GqlSettingsEcologicalFunctionType;
};

export type GqlEcologicalFunctionCreateInput = {
  answers?: InputMaybe<Scalars['GqlJSON']['input']>;
  createdAt: Scalars['DateTimeISO']['input'];
  ecologicalFunctionTypeId: Scalars['String']['input'];
  geometry: Scalars['GqlJSON']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  linkedObservationId?: InputMaybe<Scalars['String']['input']>;
  mapEditorLayerId?: InputMaybe<Scalars['String']['input']>;
  mediaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  plannerVisitId?: InputMaybe<Scalars['String']['input']>;
  preciseLocation?: InputMaybe<Scalars['GqlJSON']['input']>;
  projectId: Scalars['String']['input'];
  reportId?: InputMaybe<Scalars['String']['input']>;
  researchTypeId: Scalars['String']['input'];
  speciesIds: Array<Scalars['String']['input']>;
};

export type GqlEcologicalFunctionSearchParams = {
  layerId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlEcologicalFunctionToObservationLinkInput = {
  ecologicalFunctionId: Scalars['ID']['input'];
  observationId: Scalars['ID']['input'];
};

export type GqlEcologicalFunctionToObservationUnlinkInput = {
  ecologicalFunctionId: Scalars['ID']['input'];
  observationId: Scalars['ID']['input'];
};

export type GqlEcologicalFunctionTypeGetAutocompleteOptionsParams = {
  q?: InputMaybe<Scalars['String']['input']>;
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlEcologicalFunctionTypeGetAutocompleteOptionsPayload = {
  __typename: 'GqlEcologicalFunctionTypeGetAutocompleteOptionsPayload';
  data: Array<GqlAutocompleteOption>;
  selectedData: Array<GqlAutocompleteOption>;
};

export type GqlEcologicalFunctionUpdateInput = {
  answers?: InputMaybe<Scalars['GqlJSON']['input']>;
  createdAt: Scalars['DateTimeISO']['input'];
  ecologicalFunctionId: Scalars['ID']['input'];
  ecologicalFunctionTypeId: Scalars['ID']['input'];
  mediaIds: Array<Scalars['String']['input']>;
  preciseLocation?: InputMaybe<Scalars['GqlJSON']['input']>;
  speciesIds: Array<Scalars['String']['input']>;
};

export type GqlEcologicalFunction_CreatedByIdPayload = {
  __typename: 'GqlEcologicalFunction_createdByIdPayload';
  data?: Maybe<Scalars['String']['output']>;
  error?: Maybe<GqlFieldError>;
};

export type GqlEcologicalFunctionsByVisitGetAllPayload = {
  __typename: 'GqlEcologicalFunctionsByVisitGetAllPayload';
  data: Array<GqlEcologicalFunction>;
  queryInfo: GqlQueryInfo;
};

export type GqlEventBatch = {
  __typename: 'GqlEventBatch';
  id: Scalars['ID']['output'];
  status: GqlEventBatchStatus;
};

/** Status of this eventbatch */
export enum GqlEventBatchStatus {
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Received = 'RECEIVED'
}

export enum GqlExportTemplate {
  Default = 'default',
  Ecoresult = 'ecoresult'
}

export enum GqlFeatureType {
  LineString = 'LineString',
  Point = 'Point',
  Polygon = 'Polygon'
}

export type GqlFieldError = {
  __typename: 'GqlFieldError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GqlFieldworker = {
  __typename: 'GqlFieldworker';
  address?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<Scalars['GqlJSON']['output']>;
  coolOffBetweenShiftsInHours: Scalars['Int']['output'];
  hasConfirmedAvailability: Scalars['Boolean']['output'];
  hasFinishedOnboarding: Scalars['Boolean']['output'];
  hasOwnTransport: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isMyWheelsUser: Scalars['Boolean']['output'];
  isPayable: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['GqlJSON']['output']>;
  maxShiftsPerWeek: Scalars['Int']['output'];
  preferredTransportationMethod: GqlFieldworkerPreferredTransportationMethod;
  user: GqlUser;
  userId: Scalars['String']['output'];
};

export type GqlFieldworkerAvailability = {
  __typename: 'GqlFieldworkerAvailability';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  plannedShift?: Maybe<GqlPlannerV2Shift>;
  plannedShiftId?: Maybe<Scalars['ID']['output']>;
  status: GqlFieldworkerAvailabilityStatus;
};

export type GqlFieldworkerAvailabilityInput = {
  availabilityId: Scalars['ID']['input'];
  date: Scalars['DateTimeISO']['input'];
  isAvailable: Scalars['Boolean']['input'];
};

export enum GqlFieldworkerAvailabilityStatus {
  Available = 'available',
  Scheduled = 'scheduled',
  Unavailable = 'unavailable'
}

export type GqlFieldworkerCalendarDayEvents = {
  __typename: 'GqlFieldworkerCalendarDayEvents';
  availabilities: Array<GqlFieldworkerAvailability>;
  date: Scalars['DateTimeISO']['output'];
};

export type GqlFieldworkerCreateInput = {
  userId: Scalars['ID']['input'];
};

export type GqlFieldworkerFinishOnboardingInput = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  hasDriversLicense: Scalars['Boolean']['input'];
  hasDriversLicenseForMoreThan1Year: Scalars['Boolean']['input'];
  hasOwnTransport: Scalars['Boolean']['input'];
  is21YearsOrOlder: Scalars['Boolean']['input'];
};

export type GqlFieldworkerGetAutocompleteOptionsParams = {
  q?: InputMaybe<Scalars['String']['input']>;
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlFieldworkerGetAutocompleteOptionsPayload = {
  __typename: 'GqlFieldworkerGetAutocompleteOptionsPayload';
  data: Array<GqlAutocompleteOption>;
  selectedData: Array<GqlAutocompleteOption>;
};

export type GqlFieldworkerPayment = {
  __typename: 'GqlFieldworkerPayment';
  id: Scalars['ID']['output'];
  media?: Maybe<GqlMedia>;
  mediaId: Scalars['ID']['output'];
  paymentDate: Scalars['DateTimeISO']['output'];
  period: Scalars['DateTimeISO']['output'];
  scope: GqlFieldworkerPaymentScope;
  total: GqlFieldworkerPaymentTotal;
};

export type GqlFieldworkerPaymentCreateInput = {
  scope: GqlFieldworkerPaymentScope;
};

export type GqlFieldworkerPaymentRecord = {
  __typename: 'GqlFieldworkerPaymentRecord';
  date: Scalars['DateTimeISO']['output'];
  durationSeconds: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  paymentId: Scalars['ID']['output'];
  travelDistanceMeters: Scalars['Int']['output'];
  type: GqlPaymentRecordType;
};

export enum GqlFieldworkerPaymentScope {
  External = 'external',
  Internal = 'internal'
}

export type GqlFieldworkerPaymentTotal = {
  __typename: 'GqlFieldworkerPaymentTotal';
  daySeconds: Scalars['Float']['output'];
  nightSeconds: Scalars['Float']['output'];
  travelDistanceMeters: Scalars['Float']['output'];
};

export enum GqlFieldworkerPreferredTransportationMethod {
  Bike = 'bike',
  MyWheels = 'myWheels',
  PrivateCar = 'privateCar'
}

/** Transportation methods for filtering fieldworkers */
export enum GqlFieldworkerTransportationMethod {
  Mywheels = 'mywheels',
  OwnTransport = 'ownTransport'
}

export type GqlFieldworkerUpdateAvailabilityInput = {
  availabilities: Array<GqlFieldworkerAvailabilityInput>;
  targetId: Scalars['ID']['input'];
};

export type GqlFieldworkerUpdateInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  availability?: InputMaybe<Scalars['GqlJSON']['input']>;
  coolOffBetweenShifts?: InputMaybe<Scalars['Boolean']['input']>;
  hasConfirmedAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnTransport?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMyWheelsUser?: InputMaybe<Scalars['Boolean']['input']>;
  isPayable?: InputMaybe<Scalars['Boolean']['input']>;
  maxShiftsPerWeek?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};

export type GqlFilterOption = GqlFilterOptionBoolean | GqlFilterOptionMultiSelect | GqlFilterOptionSelect | GqlFilterOptionText;

export type GqlFilterOptionBoolean = {
  __typename: 'GqlFilterOptionBoolean';
  filterType: GqlFilterType;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type GqlFilterOptionMultiSelect = {
  __typename: 'GqlFilterOptionMultiSelect';
  dataModel: AutocompleteModel;
  filterType: GqlFilterType;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type GqlFilterOptionSelect = {
  __typename: 'GqlFilterOptionSelect';
  filterType: GqlFilterType;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<SelectOption>;
};

export type GqlFilterOptionText = {
  __typename: 'GqlFilterOptionText';
  filterType: GqlFilterType;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** Types of filters */
export enum GqlFilterType {
  Boolean = 'boolean',
  MultiSelect = 'multiSelect',
  Select = 'select',
  Text = 'text'
}

/** GeoJSON types */
export enum GqlGeoJsonType {
  Feature = 'Feature',
  FeatureCollection = 'FeatureCollection'
}

export type GqlInvoice = {
  __typename: 'GqlInvoice';
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  periodEnd: Scalars['DateTimeISO']['output'];
  periodStart: Scalars['DateTimeISO']['output'];
  projects: Array<GqlInvoicedProject>;
  totalCostInCents: Scalars['Int']['output'];
};

export type GqlInvoiceCreateInput = {
  clientId: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type GqlInvoiceCsvExport = {
  __typename: 'GqlInvoiceCsvExport';
  buffer: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type GqlInvoiceExportToCsvInput = {
  clientId: Scalars['ID']['input'];
  invoiceId: Scalars['String']['input'];
};

export type GqlInvoicePeriod = {
  __typename: 'GqlInvoicePeriod';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  month: Scalars['Int']['output'];
  numberOfRecords: Scalars['Int']['output'];
  totalCostInCents?: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
};

export type GqlInvoicedProject = {
  __typename: 'GqlInvoicedProject';
  costInCents: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  visits: Array<GqlInvoicedProjectVisit>;
};

export type GqlInvoicedProjectVisit = {
  __typename: 'GqlInvoicedProjectVisit';
  costInCents: Scalars['Float']['output'];
  date: Scalars['DateTimeISO']['output'];
  durationInSeconds: Scalars['Int']['output'];
  plannerAreaId: Scalars['ID']['output'];
  plannerAreaName: Scalars['String']['output'];
  plannerVisitId: Scalars['ID']['output'];
  pricePerHourInCents: Scalars['Int']['output'];
  protocolId: Scalars['ID']['output'];
  protocolName: Scalars['String']['output'];
  protocolVisitNumber: Scalars['Int']['output'];
  requiredFieldworkers: Scalars['Int']['output'];
  travelAllowanceKms: Scalars['Int']['output'];
  travelAllowancePerKmInCents: Scalars['Int']['output'];
  travelAllowanceTimeInSeconds: Scalars['Int']['output'];
};

export type GqlJob = {
  __typename: 'GqlJob';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Scalars['GqlJSON']['output']>;
  status: GqlJobState;
  worker: Scalars['String']['output'];
};

/** Status of background job */
export enum GqlJobState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Retry = 'RETRY'
}

export type GqlMapEditorCreateFormOption = {
  __typename: 'GqlMapEditorCreateFormOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlMapEditorFeature = {
  __typename: 'GqlMapEditorFeature';
  data: GqlMapEditorFeatureData;
  geometry: Scalars['GqlJSON']['output'];
  id: Scalars['ID']['output'];
  layer: GqlMapEditorLayer;
  layerId: Scalars['ID']['output'];
  properties: Scalars['GqlJSON']['output'];
};

export type GqlMapEditorFeatureCollection = {
  __typename: 'GqlMapEditorFeatureCollection';
  features: Array<GqlMapEditorGeoJsonFeature>;
  type: GqlGeoJsonType;
};

export type GqlMapEditorFeatureData = GqlEcologicalFunction | GqlMapEditorFeatureDataTypeOther | GqlMediaPoint | GqlObservation | GqlPlannerArea;

export type GqlMapEditorFeatureDataTypeOther = {
  __typename: 'GqlMapEditorFeatureDataTypeOther';
  mapEditorFeatureType: Scalars['String']['output'];
};

export type GqlMapEditorFeatureDeleteInput = {
  featureId: Scalars['String']['input'];
};

export type GqlMapEditorFeatureGetAllPayload = {
  __typename: 'GqlMapEditorFeatureGetAllPayload';
  data: Array<GqlMapEditorFeature>;
  queryInfo: GqlQueryInfo;
};

export type GqlMapEditorFeatureImportJob = {
  __typename: 'GqlMapEditorFeatureImportJob';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Scalars['GqlJSON']['output']>;
  status: GqlJobState;
  worker: Scalars['String']['output'];
};

export type GqlMapEditorFeatureSearchParams = {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ecologicalFunctionTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featureTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  layerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxDistanceFromSpatialAnchor?: InputMaybe<Scalars['Float']['input']>;
  nearSpatialAnchor?: InputMaybe<Array<Scalars['Float']['input']>>;
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  projectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  protocolIds?: InputMaybe<Array<Scalars['String']['input']>>;
  protocolVisitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  reportIds?: InputMaybe<Array<Scalars['String']['input']>>;
  researchTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  speciesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<GqlObservationStatus>>;
  typeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  visitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlMapEditorFeatureStartImportInput = {
  layerId: Scalars['String']['input'];
  mediaId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

export type GqlMapEditorFeatureUpdateInput = {
  featureId: Scalars['String']['input'];
  geometry: Scalars['GqlJSON']['input'];
  properties?: InputMaybe<Scalars['GqlJSON']['input']>;
};

export type GqlMapEditorGeoJsonFeature = {
  __typename: 'GqlMapEditorGeoJsonFeature';
  geometry: Scalars['GqlJSON']['output'];
  properties: Scalars['GqlJSON']['output'];
  type: GqlGeoJsonType;
};

export type GqlMapEditorGetLayerAllFeaturesParams = {
  ecologicalFunctionTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  layerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxDistanceFromSpatialAnchor?: InputMaybe<Scalars['Float']['input']>;
  nearSpatialAnchor?: InputMaybe<Array<Scalars['Float']['input']>>;
  observationTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  observationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  protocolVisitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  researchTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  speciesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  visitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlMapEditorLayer = {
  __typename: 'GqlMapEditorLayer';
  addressImportJobId?: Maybe<Scalars['String']['output']>;
  color: Scalars['String']['output'];
  config: Scalars['GqlJSON']['output'];
  featureCollection?: Maybe<GqlMapEditorFeatureCollection>;
  features: Array<GqlMapEditorFeature>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  showToClientUser: Scalars['Boolean']['output'];
  style: GqlMapEditorLayerStyle;
};

export type GqlMapEditorLayerAllFeatures = {
  __typename: 'GqlMapEditorLayerAllFeatures';
  data: Array<GqlMapEditorLayer>;
  filterOptions: Array<GqlFilterOption>;
};

export type GqlMapEditorLayerCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['GqlJSON']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  showToClientUser?: InputMaybe<Scalars['Boolean']['input']>;
  style?: InputMaybe<GqlMapEditorLayerStyle>;
};

export type GqlMapEditorLayerDeleteInput = {
  layerId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

export type GqlMapEditorLayerGetAllParams = {
  layerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  showToClientUser?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMapEditorLayerGetAllPayload = {
  __typename: 'GqlMapEditorLayerGetAllPayload';
  data: Array<GqlMapEditorLayer>;
  queryInfo: GqlQueryInfo;
};

export type GqlMapEditorLayerStartImportInput = {
  mediaId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

export enum GqlMapEditorLayerStyle {
  MapStyleDefault = 'MAP_STYLE_DEFAULT',
  MapStyleIcon = 'MAP_STYLE_ICON'
}

export type GqlMapEditorLayerUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['GqlJSON']['input']>;
  layerId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  showToClientUser?: InputMaybe<Scalars['Boolean']['input']>;
  style?: InputMaybe<GqlMapEditorLayerStyle>;
};

/** Generic shape icon usable for map markers */
export enum GqlMapShapeIcon {
  Circle = 'Circle',
  Diamond = 'Diamond',
  Hexagon = 'Hexagon',
  Pentagon = 'Pentagon',
  Plus = 'Plus',
  Square = 'Square',
  StarFive = 'StarFive',
  StarFour = 'StarFour',
  StarSix = 'StarSix',
  StarThree = 'StarThree',
  TriangleDown = 'TriangleDown',
  TriangleUp = 'TriangleUp'
}

export type GqlMeClient = {
  __typename: 'GqlMeClient';
  client: GqlClient;
  permissions: Array<ClientPermission>;
};

export type GqlMeProject = {
  __typename: 'GqlMeProject';
  permissions: Array<ProjectPermission>;
  project: GqlProject;
};

export type GqlMeUser = {
  __typename: 'GqlMeUser';
  sudoUser?: Maybe<GqlUser>;
  tenant: GqlTenant;
  user: GqlUser;
};

export type GqlMedia = {
  __typename: 'GqlMedia';
  id: Scalars['ID']['output'];
  isUploaded: Scalars['Boolean']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlMediaCreateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type GqlMediaPoint = {
  __typename: 'GqlMediaPoint';
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: GqlUser;
  createdByUserId: Scalars['ID']['output'];
  feature: GqlMapEditorFeature;
  id: Scalars['ID']['output'];
  mapEditorFeatureId: Scalars['ID']['output'];
  media: GqlMedia;
  mediaId: Scalars['ID']['output'];
  observationMediaPointSpecies: Array<GqlObservationMediaPointSpecies>;
  observations: Array<GqlObservation>;
  plannerVisitId?: Maybe<Scalars['ID']['output']>;
  plannerVisitWorkerReportId?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['ID']['output'];
};

export type GqlMediaSetUploadedInput = {
  mediaId: Scalars['ID']['input'];
};

export type GqlNotification = {
  __typename: 'GqlNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  ctaTitle?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  isSent: Scalars['Boolean']['output'];
  receiverId: Scalars['ID']['output'];
  sender?: Maybe<GqlUser>;
  senderId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

export type GqlNotificationCreateInput = {
  body: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['ID']['input']>;
  ctaTitle: Scalars['String']['input'];
  ctaUrl: Scalars['String']['input'];
  receiverId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type GqlNotificationGetAllParams = {
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlNotificationGetAllPayload = {
  __typename: 'GqlNotificationGetAllPayload';
  data: Array<GqlNotification>;
  queryInfo: GqlQueryInfo;
  unreadCount: Scalars['Float']['output'];
};

export type GqlNotificationMarkAsReadInput = {
  notificationIds: Array<Scalars['ID']['input']>;
};

export type GqlObservation = {
  __typename: 'GqlObservation';
  answers?: Maybe<Scalars['GqlJSON']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdById: GqlObservation_CreatedByIdPayload;
  createdByUser: ObservationFieldResolver_CreatedByUserPayload;
  ecologicalFunctions: Array<GqlEcologicalFunction>;
  feature: GqlMapEditorFeature;
  featureId: Scalars['String']['output'];
  feedbackComment: GqlObservation_FeedbackCommentPayload;
  feedbackRating: GqlObservation_FeedbackRatingPayload;
  id: Scalars['ID']['output'];
  mediaPoints: Array<GqlMediaPoint>;
  medias: Array<GqlMedia>;
  observationTypeId: Scalars['String']['output'];
  plannerVisitId?: Maybe<Scalars['String']['output']>;
  preciseLocation?: Maybe<Scalars['GqlJSON']['output']>;
  projectId: Scalars['String']['output'];
  reportId?: Maybe<Scalars['String']['output']>;
  researchType: GqlSettingsResearchType;
  researchTypeId: Scalars['ID']['output'];
  species: GqlSettingsSpecies;
  speciesId: Scalars['String']['output'];
  status: GqlObservation_StatusPayload;
  type: GqlSettingsObservationType;
};

export type GqlObservationAddMediaPointInput = {
  observationId: Scalars['ID']['input'];
  observationMediaPointId: Scalars['ID']['input'];
};

export type GqlObservationCloneInput = {
  observationId: Scalars['ID']['input'];
};

export type GqlObservationDeleteMediaPointInput = {
  observationId: Scalars['ID']['input'];
  observationMediaPointId: Scalars['ID']['input'];
};

export type GqlObservationMediaPointSpecies = {
  __typename: 'GqlObservationMediaPointSpecies';
  callTypes: Array<Scalars['String']['output']>;
  confidence: Scalars['Float']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  detections: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  observationMediaPoint: GqlMediaPoint;
  observationMediaPointId: Scalars['ID']['output'];
  processor: Scalars['String']['output'];
  species: GqlSettingsSpecies;
  speciesId: Scalars['ID']['output'];
};

export type GqlObservationMediaPointUpdateInput = {
  createdAt: Scalars['DateTimeISO']['input'];
  observationMediaPointId: Scalars['ID']['input'];
  speciesIds: Array<Scalars['ID']['input']>;
};

/** Observation status */
export enum GqlObservationStatus {
  Approved = 'approved',
  AwaitingApproval = 'awaitingApproval',
  Deleted = 'deleted',
  Incomplete = 'incomplete',
  Rejected = 'rejected'
}

export type GqlObservationStatusChangeInput = {
  observationId: Scalars['ID']['input'];
  status: GqlObservationStatus;
};

export type GqlObservationUpdateInput = {
  answers?: InputMaybe<Scalars['GqlJSON']['input']>;
  createdAt: Scalars['DateTimeISO']['input'];
  feedbackComment?: InputMaybe<Scalars['String']['input']>;
  feedbackRating?: InputMaybe<Scalars['Boolean']['input']>;
  mediaIds: Array<Scalars['String']['input']>;
  observationId: Scalars['ID']['input'];
  observationTypeId: Scalars['ID']['input'];
  preciseLocation?: InputMaybe<Scalars['GqlJSON']['input']>;
  speciesId: Scalars['ID']['input'];
};

export type GqlObservationValidationStatusError = {
  __typename: 'GqlObservationValidationStatusError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type GqlObservationValidationStatusPayload = {
  __typename: 'GqlObservationValidationStatusPayload';
  errors?: Maybe<Array<GqlObservationValidationStatusError>>;
  success: Scalars['Boolean']['output'];
};

export type GqlObservation_CreatedByIdPayload = {
  __typename: 'GqlObservation_createdByIdPayload';
  data?: Maybe<Scalars['String']['output']>;
  error?: Maybe<GqlFieldError>;
};

export type GqlObservation_FeedbackCommentPayload = {
  __typename: 'GqlObservation_feedbackCommentPayload';
  data?: Maybe<Scalars['String']['output']>;
  error?: Maybe<GqlFieldError>;
};

export type GqlObservation_FeedbackRatingPayload = {
  __typename: 'GqlObservation_feedbackRatingPayload';
  data?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<GqlFieldError>;
};

export type GqlObservation_StatusPayload = {
  __typename: 'GqlObservation_statusPayload';
  data?: Maybe<GqlObservationStatus>;
  error?: Maybe<GqlFieldError>;
};

export type GqlObservationsBulkApproveByVisitInput = {
  plannerVisitId: Scalars['ID']['input'];
};

export type GqlObservationsByVisitGetAllPayload = {
  __typename: 'GqlObservationsByVisitGetAllPayload';
  data: Array<GqlObservation>;
  queryInfo: GqlQueryInfo;
};

export type GqlObservationsByVisitSearchParams = {
  layerId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlObservationsGetAllForFinalReportPayload = {
  __typename: 'GqlObservationsGetAllForFinalReportPayload';
  data: Array<GqlObservation>;
  isObservationsSectionAllowed: Scalars['Boolean']['output'];
};

export type GqlPaginationOption = {
  __typename: 'GqlPaginationOption';
  page: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export enum GqlPaymentRecordType {
  Day = 'day',
  Night = 'night'
}

export enum GqlPermissions {
  Administrator = 'Administrator',
  Customer = 'Customer',
  Fieldworker = 'Fieldworker'
}

export type GqlPlannerArea = {
  __typename: 'GqlPlannerArea';
  address?: Maybe<Scalars['String']['output']>;
  allowedActions: GqlPlannerV2AreaActions;
  descriptionClient?: Maybe<Scalars['String']['output']>;
  descriptionFieldworker?: Maybe<Scalars['String']['output']>;
  descriptionInternal?: Maybe<Scalars['String']['output']>;
  featureId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: Scalars['GqlJSON']['output'];
  mediasClient: GqlPlannerAreaFieldResolver_MediasClientPayload;
  mediasFieldworker: GqlPlannerAreaFieldResolver_MediasFieldworkerPayload;
  mediasInternal: GqlPlannerAreaFieldResolver_MediasInternalPayload;
  name: Scalars['String']['output'];
  project: GqlProject;
  projectId: Scalars['String']['output'];
  protocols: Array<GqlPlannerAreaProtocol>;
  status: GqlPlannerV2AreaStatus;
  visits: Array<GqlPlannerV2Visit>;
};

export type GqlPlannerAreaAutocompleteOption = {
  __typename: 'GqlPlannerAreaAutocompleteOption';
  clientId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
};

export type GqlPlannerAreaFieldResolver_MediasClientPayload = {
  __typename: 'GqlPlannerAreaFieldResolver_mediasClientPayload';
  data?: Maybe<Array<GqlMedia>>;
  error?: Maybe<GqlFieldError>;
};

export type GqlPlannerAreaFieldResolver_MediasFieldworkerPayload = {
  __typename: 'GqlPlannerAreaFieldResolver_mediasFieldworkerPayload';
  data?: Maybe<Array<GqlMedia>>;
  error?: Maybe<GqlFieldError>;
};

export type GqlPlannerAreaFieldResolver_MediasInternalPayload = {
  __typename: 'GqlPlannerAreaFieldResolver_mediasInternalPayload';
  data?: Maybe<Array<GqlMedia>>;
  error?: Maybe<GqlFieldError>;
};

export type GqlPlannerAreaGetAutocompleteOptionsParams = {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  projectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<GqlPlannerV2AreaStatus>>;
};

export type GqlPlannerAreaGetAutocompleteOptionsPayload = {
  __typename: 'GqlPlannerAreaGetAutocompleteOptionsPayload';
  data: Array<GqlPlannerAreaAutocompleteOption>;
  selectedData: Array<GqlPlannerAreaAutocompleteOption>;
};

export type GqlPlannerAreaInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  descriptionClient?: InputMaybe<Scalars['String']['input']>;
  descriptionFieldworker?: InputMaybe<Scalars['String']['input']>;
  descriptionInternal?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GqlPlannerV2AreaStatus>;
};

export type GqlPlannerAreaMediaAddInput = {
  audience: GqlPlannerAreaMediaAudience;
  mediaIds: Array<Scalars['ID']['input']>;
  plannerAreaId: Scalars['ID']['input'];
};

export enum GqlPlannerAreaMediaAudience {
  Client = 'client',
  Fieldworker = 'fieldworker',
  Internal = 'internal'
}

export type GqlPlannerAreaMediaRemoveInput = {
  mediaId: Scalars['ID']['input'];
  plannerAreaId: Scalars['ID']['input'];
};

export type GqlPlannerAreaProtocol = {
  __typename: 'GqlPlannerAreaProtocol';
  id: Scalars['ID']['output'];
  protocol: GqlProtocol;
  protocolId: Scalars['ID']['output'];
  requiredFieldworkers: Scalars['Float']['output'];
};

export type GqlPlannerAreaRemoveProtocolInput = {
  plannerAreaId: Scalars['ID']['input'];
  protocolId: Scalars['ID']['input'];
};

export type GqlPlannerAreaSaveProtocolInput = {
  plannerAreaId: Scalars['ID']['input'];
  protocolId: Scalars['ID']['input'];
};

export type GqlPlannerAreaUpdateInput = {
  data: GqlPlannerAreaInput;
  plannerAreaId: Scalars['ID']['input'];
};

export enum GqlPlannerShiftCompletionStatus {
  Approved = 'approved',
  AwaitingApproval = 'awaitingApproval',
  AwaitingReport = 'awaitingReport',
  Planned = 'planned'
}

export enum GqlPlannerTravelGroupAttendanceType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export enum GqlPlannerTravelGroupOwnerBillingType {
  MyWheels = 'myWheels',
  None = 'none',
  PrivateCar = 'privateCar'
}

export enum GqlPlannerTravelGroupStatus {
  Aborted = 'aborted',
  Live = 'live',
  Upsert = 'upsert'
}

export type GqlPlannerV2Area = {
  __typename: 'GqlPlannerV2Area';
  address: Scalars['String']['output'];
  allowedActions: GqlPlannerV2AreaActions;
  boundingBox?: Maybe<Array<Scalars['Float']['output']>>;
  descriptionClient?: Maybe<Scalars['String']['output']>;
  descriptionFieldworker?: Maybe<Scalars['String']['output']>;
  descriptionInternal?: Maybe<Scalars['String']['output']>;
  earliestPlannerVisitDaysRemaining?: Maybe<Scalars['Int']['output']>;
  featureId: Scalars['String']['output'];
  hasStagedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location: Scalars['GqlJSON']['output'];
  mapEditorFeature: GqlMapEditorFeature;
  medias: Array<GqlMedia>;
  mediasClient: PlannerAreaFieldResolver_MediasClientPayload;
  mediasFieldworker: PlannerAreaFieldResolver_MediasFieldworkerPayload;
  mediasInternal: PlannerAreaFieldResolver_MediasInternalPayload;
  name: Scalars['String']['output'];
  number: Scalars['Float']['output'];
  plannerStatusBucket: Scalars['String']['output'];
  plannerVisits: Array<GqlPlannerV2Visit>;
  project: GqlProject;
  projectId: Scalars['String']['output'];
  status: GqlPlannerV2AreaStatus;
};


export type GqlPlannerV2AreaEarliestPlannerVisitDaysRemainingArgs = {
  onDate: Scalars['DateTimeISO']['input'];
};


export type GqlPlannerV2AreaPlannerStatusBucketArgs = {
  onDate: Scalars['DateTimeISO']['input'];
};


export type GqlPlannerV2AreaPlannerVisitsArgs = {
  maxRequiredFieldworkers?: InputMaybe<Scalars['Int']['input']>;
  onDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  plannerStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  researchTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlPlannerV2AreaActions = {
  __typename: 'GqlPlannerV2AreaActions';
  changeStatus: ConditionalAction;
};

export type GqlPlannerV2AreaGetAllByProjectIdPayload = {
  __typename: 'GqlPlannerV2AreaGetAllByProjectIdPayload';
  data: Array<GqlPlannerV2Area>;
};

export enum GqlPlannerV2AreaStatus {
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  OnHold = 'onHold'
}

export type GqlPlannerV2AreasGetInBoundingBoxPayload = {
  __typename: 'GqlPlannerV2AreasGetInBoundingBoxPayload';
  impossible: Array<GqlPlannerV2Area>;
  notYetPlannable: Array<GqlPlannerV2Area>;
  outOfProtocol: Array<GqlPlannerV2Area>;
  plannableAtRisk: Array<GqlPlannerV2Area>;
  plannableOk: Array<GqlPlannerV2Area>;
  plannableSoon: Array<GqlPlannerV2Area>;
  planned: Array<GqlPlannerV2Area>;
};

export type GqlPlannerV2AvailableTransportationMethod = {
  __typename: 'GqlPlannerV2AvailableTransportationMethod';
  distanceInMeters: Scalars['Int']['output'];
  durationInSeconds: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  transportationMethod: GqlPlannerV2TransportationMethod;
};

export type GqlPlannerV2CombinableVisitPayload = {
  __typename: 'GqlPlannerV2CombinableVisitPayload';
  _id: Scalars['ID']['output'];
  plannerVisit: GqlPlannerV2Visit;
  plannerVisitId: Scalars['ID']['output'];
  timeslotId: Scalars['ID']['output'];
};

export type GqlPlannerV2FieldworkerMergePickupDropoffLocationInput = {
  destinationPlannerShiftId: Scalars['ID']['input'];
  plannerTravelGroupId: Scalars['ID']['input'];
  sourcePlannerShiftId: Scalars['ID']['input'];
};

export type GqlPlannerV2FieldworkerMovePickupDropoffLocationInput = {
  plannerShiftId: Scalars['ID']['input'];
  plannerTravelGroupId: Scalars['ID']['input'];
  point: Scalars['GqlJSON']['input'];
};

export type GqlPlannerV2FieldworkerRemovePickupDropoffLocationInput = {
  plannerShiftId: Scalars['ID']['input'];
  plannerTravelGroupId: Scalars['ID']['input'];
};

export type GqlPlannerV2FieldworkerStraightTravelDistance = {
  __typename: 'GqlPlannerV2FieldworkerStraightTravelDistance';
  availableTransportationMethods: Array<GqlPlannerV2AvailableTransportationMethod>;
  fieldworker: GqlFieldworker;
  fieldworkerId: Scalars['ID']['output'];
  plannerVisit: GqlPlannerV2Visit;
  plannerVisitId: Scalars['ID']['output'];
  user: GqlUser;
};

export type GqlPlannerV2MapElementPoint = {
  __typename: 'GqlPlannerV2MapElementPoint';
  _id: Scalars['ID']['output'];
  locationPoint: Scalars['GqlJSON']['output'];
  numberOfPlannerShiftsEnteringExiting: Scalars['Int']['output'];
  plannerShiftTravels: Array<GqlPlannerV2ShiftTravel>;
  plannerTravelGroupId: Scalars['ID']['output'];
  type: GqlPlannerV2MapElementPointType;
};

export enum GqlPlannerV2MapElementPointType {
  FieldworkerStartExit = 'fieldworkerStartExit',
  OwnerStartExit = 'ownerStartExit',
  PickupDropoff = 'pickupDropoff'
}

export type GqlPlannerV2MapElementsPayload = {
  __typename: 'GqlPlannerV2MapElementsPayload';
  _id: Scalars['ID']['output'];
  fieldworkersStaged: Array<GqlFieldworker>;
  plannerTravels: Array<GqlPlannerV2Travel>;
  plannerVisits: Array<GqlPlannerV2Visit>;
  points: Array<GqlPlannerV2MapElementPoint>;
};

export type GqlPlannerV2PossibleDays = {
  __typename: 'GqlPlannerV2PossibleDays';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type GqlPlannerV2PossibleTime = {
  __typename: 'GqlPlannerV2PossibleTime';
  _id: Scalars['ID']['output'];
  endTime: Scalars['DateTimeISO']['output'];
  startTime: Scalars['DateTimeISO']['output'];
  timeslotId: Scalars['ID']['output'];
};

export type GqlPlannerV2ReviewScheduleItemPayload = {
  __typename: 'GqlPlannerV2ReviewScheduleItemPayload';
  _id: Scalars['ID']['output'];
  plannerArea: GqlPlannerV2Area;
  plannerVisits: Array<GqlPlannerV2Visit>;
};

export type GqlPlannerV2ReviewSchedulePayload = {
  __typename: 'GqlPlannerV2ReviewSchedulePayload';
  _id: Scalars['ID']['output'];
  toBeCancelled: Array<GqlPlannerV2ReviewScheduleItemPayload>;
  toBePlanned: Array<GqlPlannerV2ReviewScheduleItemPayload>;
};

export type GqlPlannerV2ScheduleCancelInput = {
  plannerVisitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GqlPlannerV2ScheduleConfirmInput = {
  plannerVisitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GqlPlannerV2Shift = {
  __typename: 'GqlPlannerV2Shift';
  createdAt: Scalars['DateTimeISO']['output'];
  durationInSeconds: Scalars['Float']['output'];
  endTime: Scalars['DateTimeISO']['output'];
  fieldworker: GqlFieldworker;
  fieldworkerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  payments: Array<GqlFieldworkerPaymentRecord>;
  plannerShiftTravels: Array<GqlPlannerV2ShiftTravel>;
  plannerTravelGroups: Array<GqlPlannerV2ShiftPlannerTravelGroup>;
  plannerVisits: Array<GqlPlannerV2Visit>;
  readyForPayment: Scalars['Boolean']['output'];
  stableId: Scalars['ID']['output'];
  startTime: Scalars['DateTimeISO']['output'];
  status: GqlPlannerV2ShiftStatus;
  summary: GqlPlannerV2ShiftSummary;
  user: GqlUser;
};

export type GqlPlannerV2ShiftCreateFromVisitInput = {
  allowIfUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
  fieldworkerId: Scalars['ID']['input'];
  onDate: Scalars['DateTimeISO']['input'];
  plannerVisitId: Scalars['ID']['input'];
  timeslotId: Scalars['ID']['input'];
  transportationMethod: GqlPlannerV2TransportationMethod;
};

export type GqlPlannerV2ShiftMarkReadyForPaymentInput = {
  plannerShiftId: Scalars['ID']['input'];
  readyForPayment: Scalars['Boolean']['input'];
};

export type GqlPlannerV2ShiftPlannerTravelGroup = {
  __typename: 'GqlPlannerV2ShiftPlannerTravelGroup';
  id: Scalars['ID']['output'];
  isMeOwner: Scalars['Boolean']['output'];
  ownerBillingType: GqlPlannerTravelGroupOwnerBillingType;
  ownerPlannerShift: GqlPlannerV2Shift;
  ownerPlannerShiftId: Scalars['ID']['output'];
  plannerShifts: Array<GqlPlannerV2Shift>;
  plannerTravelGroupParticipants: Array<GqlFieldworker>;
  plannerTravels: Array<GqlPlannerV2Travel>;
  returnPlannerTravelGroupId: Scalars['ID']['output'];
  status: GqlPlannerTravelGroupStatus;
  timeline: Array<GqlPlannerV2ShiftTimelineItem>;
};

export enum GqlPlannerV2ShiftStatus {
  Aborted = 'aborted',
  Live = 'live',
  Upsert = 'upsert'
}

export type GqlPlannerV2ShiftSummary = {
  __typename: 'GqlPlannerV2ShiftSummary';
  completionStatus: GqlPlannerShiftCompletionStatus;
  distanceInMeters: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isMeOwner: Scalars['Boolean']['output'];
  mapPreviewGeometry?: Maybe<Scalars['GqlJSON']['output']>;
  numberOfPlannerTravelGroupParticipants: Scalars['Int']['output'];
  plannerAreaAddress: Scalars['String']['output'];
  plannerAreaHeading: Scalars['String']['output'];
  plannerAreaId: Scalars['ID']['output'];
  plannerTravelGroupOwner: GqlFieldworker;
  plannerTravelGroupOwnerId: Scalars['ID']['output'];
  plannerTravelGroupParticipants: Array<GqlFieldworker>;
  projectId: Scalars['ID']['output'];
  projectSlug: Scalars['String']['output'];
  protocolHeading: Scalars['String']['output'];
  transportationMethod: GqlPlannerV2TransportationMethod;
  travelMethod: GqlPlannerV2SummaryTravelMethod;
};

export type GqlPlannerV2ShiftTimelineItem = GqlPlannerV2Travel | GqlPlannerV2Visit;

export type GqlPlannerV2ShiftTravel = {
  __typename: 'GqlPlannerV2ShiftTravel';
  id: Scalars['ID']['output'];
  plannerShift: GqlPlannerV2Shift;
  plannerShiftId: Scalars['ID']['output'];
  plannerTravel: GqlPlannerV2Travel;
  plannerTravelId: Scalars['ID']['output'];
  presenceType: GqlPlannerV2ShiftTravelType;
};

export enum GqlPlannerV2ShiftTravelType {
  Enter = 'enter',
  EnterAndExit = 'enterAndExit',
  Exit = 'exit',
  Stay = 'stay'
}

export type GqlPlannerV2ShiftsGetAll = {
  __typename: 'GqlPlannerV2ShiftsGetAll';
  data: Array<GqlPlannerV2Shift>;
  queryInfo: GqlQueryInfo;
};

export type GqlPlannerV2ShiftsGetAllArgs = {
  afterDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  plannerShiftCompletionStatus?: InputMaybe<GqlPlannerShiftCompletionStatus>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum GqlPlannerV2SummaryTravelMethod {
  Bike = 'bike',
  MyWheels = 'myWheels',
  PrivateCar = 'privateCar',
  Walk = 'walk'
}

export enum GqlPlannerV2TransportationMethod {
  Bike = 'bike',
  Car = 'car',
  Walk = 'walk'
}

export type GqlPlannerV2Travel = {
  __typename: 'GqlPlannerV2Travel';
  departureAddress: Scalars['String']['output'];
  departurePoint: Scalars['GqlJSON']['output'];
  destinationAddress: Scalars['String']['output'];
  destinationPoint: Scalars['GqlJSON']['output'];
  distanceInMeters: Scalars['Int']['output'];
  durationInSeconds: Scalars['Int']['output'];
  endTime: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  plannerShiftDropoffs: Array<GqlPlannerV2Shift>;
  plannerShiftPickups: Array<GqlPlannerV2Shift>;
  routeGeometry: Scalars['GqlJSON']['output'];
  routePolyline: Scalars['GqlJSON']['output'];
  startTime: Scalars['DateTimeISO']['output'];
  transportationMethod: GqlPlannerV2TransportationMethod;
  type: GqlPlannerV2TravelType;
  waitTimeInSeconds: Scalars['Int']['output'];
};

export type GqlPlannerV2TravelGroup = {
  __typename: 'GqlPlannerV2TravelGroup';
  id: Scalars['ID']['output'];
  ownerBillingType: GqlPlannerTravelGroupOwnerBillingType;
  ownerPlannerShift: GqlPlannerV2Shift;
  ownerPlannerShiftId: Scalars['ID']['output'];
  plannerShifts: Array<GqlPlannerV2Shift>;
  plannerTravelGroupParticipants: Array<GqlFieldworker>;
  plannerTravels: Array<GqlPlannerV2Travel>;
  returnPlannerTravelGroupId: Scalars['ID']['output'];
  status: GqlPlannerTravelGroupStatus;
};

export type GqlPlannerV2TravelGroupAddFieldworkerInput = {
  allowIfUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
  fieldworkerId: Scalars['ID']['input'];
  plannerTravelGroupId: Scalars['ID']['input'];
};

export type GqlPlannerV2TravelGroupAddVisitInput = {
  allowIfUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
  plannerTravelGroupId: Scalars['ID']['input'];
  plannerVisitId: Scalars['ID']['input'];
  timeslotId: Scalars['ID']['input'];
};

export type GqlPlannerV2TravelGroupAttendance = {
  __typename: 'GqlPlannerV2TravelGroupAttendance';
  id: Scalars['ID']['output'];
  plannerTravelGroup: GqlPlannerV2TravelGroup;
  plannerTravelGroupId: Scalars['ID']['output'];
  plannerVisit: GqlPlannerV2Visit;
  plannerVisitId: Scalars['ID']['output'];
  type: GqlPlannerTravelGroupAttendanceType;
};

export type GqlPlannerV2TravelGroupCancelInput = {
  plannerTravelGroupId: Scalars['ID']['input'];
};

export type GqlPlannerV2TravelGroupCancelShift = {
  plannerShiftId: Scalars['ID']['input'];
  plannerTravelGroupId: Scalars['ID']['input'];
};

export type GqlPlannerV2TravelGroupGetAdditionalVisitsPayload = {
  __typename: 'GqlPlannerV2TravelGroupGetAdditionalVisitsPayload';
  _id: Scalars['ID']['output'];
  combinable: Array<GqlPlannerV2CombinableVisitPayload>;
  plannerArea: GqlPlannerV2Area;
  plannerAreaId: Scalars['ID']['output'];
};

export type GqlPlannerV2TravelGroupRemoveVisitInput = {
  plannerTravelGroupId: Scalars['ID']['input'];
  plannerVisitId: Scalars['ID']['input'];
};

export type GqlPlannerV2TravelGroupTimelineItem = GqlPlannerV2TravelGroupTravelTimelineItem | GqlPlannerV2Visit;

export type GqlPlannerV2TravelGroupTimelinePayload = {
  __typename: 'GqlPlannerV2TravelGroupTimelinePayload';
  distanceInMeters: Scalars['Float']['output'];
  durationInSeconds: Scalars['Float']['output'];
  endTime: Scalars['DateTimeISO']['output'];
  plannerTravelGroup: GqlPlannerV2TravelGroup;
  plannerTravelGroupId: Scalars['ID']['output'];
  startTime: Scalars['DateTimeISO']['output'];
  timeline: Array<GqlPlannerV2TravelGroupTimelineItem>;
};

export type GqlPlannerV2TravelGroupTravelTimelineItem = {
  __typename: 'GqlPlannerV2TravelGroupTravelTimelineItem';
  direction: Scalars['String']['output'];
  distanceInMeters: Scalars['Int']['output'];
  dropoffs: Array<GqlPlannerV2Shift>;
  durationInSeconds: Scalars['Int']['output'];
  endTime: Scalars['DateTimeISO']['output'];
  numberInSequence: Scalars['Int']['output'];
  pickups: Array<GqlPlannerV2Shift>;
  plannerTravelId: Scalars['ID']['output'];
  startTime: Scalars['DateTimeISO']['output'];
  totalCount: Scalars['Int']['output'];
  waitTimeInSeconds: Scalars['Int']['output'];
};

export enum GqlPlannerV2TravelType {
  Adjacent = 'adjacent',
  Primary = 'primary',
  Secondary = 'secondary'
}

export type GqlPlannerV2Visit = {
  __typename: 'GqlPlannerV2Visit';
  approvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  approvedByUser?: Maybe<GqlUser>;
  approvedByUserId?: Maybe<Scalars['ID']['output']>;
  availableDaysLeft?: Maybe<Scalars['Float']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedByUser?: Maybe<GqlUser>;
  deletedByUserId?: Maybe<Scalars['ID']['output']>;
  deletionReason?: Maybe<Scalars['String']['output']>;
  deviatedFromProtocolNotes?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['DateTimeISO']['output']>;
  fieldworkLayers: Array<GqlMapEditorLayer>;
  fieldworkers: Array<GqlFieldworker>;
  fieldworkersStaged: Array<GqlFieldworker>;
  generateSummaryJobId?: Maybe<Scalars['String']['output']>;
  hasDeviatedFromProtocol: Scalars['Boolean']['output'];
  hasStagedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  plannedFieldworkers: Scalars['Int']['output'];
  plannedFieldworkersStaged: Scalars['Int']['output'];
  plannerArea: GqlPlannerV2Area;
  plannerAreaId: Scalars['ID']['output'];
  plannerStatus: GqlPlannerV2VisitPossibleDaysStatus;
  possibleDays: Array<GqlPlannerV2PossibleDays>;
  protocol: GqlProtocol;
  protocolId: Scalars['ID']['output'];
  protocolVisit: GqlProtocolVisit;
  protocolVisitId: Scalars['ID']['output'];
  rejectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  rejectedByUser?: Maybe<GqlUser>;
  rejectedByUserId?: Maybe<Scalars['ID']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  reportFromMeV2?: Maybe<GqlPlannerVisitV2WorkerReport>;
  reportsV2: Array<GqlPlannerVisitV2WorkerReport>;
  requiredFieldworkers: Scalars['Int']['output'];
  route?: Maybe<Scalars['GqlJSON']['output']>;
  routeStartDirection?: Maybe<GqlPlannerVisitRouteStartDirectionV2>;
  routeStartOffset?: Maybe<Scalars['Int']['output']>;
  simplifiedStatus: GqlPlannerV2VisitSimplifiedStatus;
  solarTime?: Maybe<GqlPlannerV2VisitSolarTime>;
  stagedByUser: PlannerVisitFieldResolver_StagedByUserPayload;
  startForm?: Maybe<Scalars['GqlJSON']['output']>;
  startTime?: Maybe<Scalars['DateTimeISO']['output']>;
  status: GqlPlannerVisitStatus;
  summaryText?: Maybe<Scalars['String']['output']>;
  teamCaptainFieldworker?: Maybe<GqlFieldworker>;
  teamCaptainFieldworkerId?: Maybe<Scalars['ID']['output']>;
  timeProtocolAutoValidationOverriddenAt?: Maybe<Scalars['DateTimeISO']['output']>;
  timeProtocolAutoValidationOverriddenReason?: Maybe<Scalars['String']['output']>;
  timeslotId?: Maybe<Scalars['ID']['output']>;
  weatherProtocolAutoValidationOverriddenAt?: Maybe<Scalars['DateTimeISO']['output']>;
  weatherProtocolAutoValidationOverriddenReason?: Maybe<Scalars['String']['output']>;
};


export type GqlPlannerV2VisitPlannerStatusArgs = {
  onDate: Scalars['DateTimeISO']['input'];
};

export type GqlPlannerV2VisitChangeTeamCaptainInput = {
  plannerVisitId: Scalars['ID']['input'];
  teamCaptainFieldworkerId: Scalars['ID']['input'];
};

export type GqlPlannerV2VisitDeleteInput = {
  deletionReason: Scalars['String']['input'];
  plannerVisitId: Scalars['ID']['input'];
};

export type GqlPlannerV2VisitGetAllParams = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fieldworkerId?: InputMaybe<Array<Scalars['ID']['input']>>;
  includesObservationLeadingToEcologicalFunctionTypeId?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPossibleBatRoost?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  plannerAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  plannerAreaName?: InputMaybe<Scalars['String']['input']>;
  plannerVisitSimplifiedStatus?: InputMaybe<GqlPlannerV2VisitSimplifiedStatus>;
  plannerVisitStatus?: InputMaybe<GqlPlannerVisitStatus>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectStatus?: InputMaybe<Array<GqlProjectStatus>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  speciesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  withoutPossibleEcologicalFunctions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPlannerV2VisitGetAllPayload = {
  __typename: 'GqlPlannerV2VisitGetAllPayload';
  data: Array<GqlPlannerV2Visit>;
  queryInfo: GqlQueryInfo;
};

export type GqlPlannerV2VisitPlannedOnDate = {
  __typename: 'GqlPlannerV2VisitPlannedOnDate';
  date: Scalars['DateTimeISO']['output'];
  numberOfPlannerTravelGroups: Scalars['Int']['output'];
};

export enum GqlPlannerV2VisitPossibleDaysStatus {
  Impossible = 'impossible',
  NotYetPlannable = 'notYetPlannable',
  OutOfProtocol = 'outOfProtocol',
  PlannableAtRisk = 'plannableAtRisk',
  PlannableOk = 'plannableOk',
  PlannableSoon = 'plannableSoon',
  Planned = 'planned'
}

export type GqlPlannerV2VisitSetRequiredFieldworkersInput = {
  plannerVisitId: Scalars['ID']['input'];
  requiredFieldworkers: Scalars['Int']['input'];
};

export enum GqlPlannerV2VisitSimplifiedStatus {
  Approved = 'approved',
  EcoTeamReview = 'ecoTeamReview',
  Planned = 'planned',
  Unplanned = 'unplanned'
}

export type GqlPlannerV2VisitSolarTime = {
  __typename: 'GqlPlannerV2VisitSolarTime';
  sunriseTime: Scalars['DateTimeISO']['output'];
  sunsetTime: Scalars['DateTimeISO']['output'];
};

export type GqlPlannerVisitPossibleFunctionObservationsPayload = {
  __typename: 'GqlPlannerVisitPossibleFunctionObservationsPayload';
  data: Array<GqlObservation>;
  queryInfo: GqlQueryInfo;
};

export type GqlPlannerVisitPossibleFunctionObservationsSearchParams = {
  layerId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export enum GqlPlannerVisitRouteStartDirectionV2 {
  Forward = 'forward',
  Reverse = 'reverse'
}

export enum GqlPlannerVisitStatus {
  Approved = 'approved',
  AwaitingApproval = 'awaitingApproval',
  AwaitingConfirm = 'awaitingConfirm',
  AwaitingObservationApproval = 'awaitingObservationApproval',
  AwaitingReport = 'awaitingReport',
  Planned = 'planned',
  Unplanned = 'unplanned'
}

export type GqlPlannerVisitSummaryRegenerateInput = {
  plannerVisitId: Scalars['ID']['input'];
};

export type GqlPlannerVisitSummaryRegeneratePayload = {
  __typename: 'GqlPlannerVisitSummaryRegeneratePayload';
  plannerVisit: GqlPlannerV2Visit;
  written: Scalars['Boolean']['output'];
};

export type GqlPlannerVisitTimeAutoValidationOverrideInput = {
  plannerVisitId: Scalars['ID']['input'];
  timeProtocolAutoValidationOverriddenAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  timeProtocolAutoValidationOverriddenReason?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPlannerVisitV2WorkerReport = {
  __typename: 'GqlPlannerVisitV2WorkerReport';
  feedbackComment?: Maybe<Scalars['String']['output']>;
  feedbackRating?: Maybe<Scalars['Boolean']['output']>;
  hasValidTimeRange: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isOutOfProtocol: Scalars['Boolean']['output'];
  mediaPoints: Array<GqlMediaPoint>;
  notes?: Maybe<Scalars['String']['output']>;
  numberOfFeedbackComments: Scalars['Float']['output'];
  observations: Array<GqlObservation>;
  outOfProtocolNotes?: Maybe<Scalars['String']['output']>;
  plannerShift: GqlPlannerV2Shift;
  plannerShiftId: Scalars['ID']['output'];
  plannerVisit: GqlPlannerV2Visit;
  plannerVisitId: Scalars['ID']['output'];
  shiftId: Scalars['ID']['output'];
  startForm?: Maybe<Scalars['GqlJSON']['output']>;
  startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status: GqlWorkerVisitReportStatus;
  stoppedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  stoppedForm?: Maybe<Scalars['GqlJSON']['output']>;
  submittedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  submittedForm?: Maybe<Scalars['GqlJSON']['output']>;
  user?: Maybe<GqlUser>;
  userId: Scalars['ID']['output'];
  visitId: Scalars['ID']['output'];
};


export type GqlPlannerVisitV2WorkerReportObservationsArgs = {
  hasFeedback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPlannerVisitV2WorkerReportUpdateInput = {
  feedbackComment?: InputMaybe<Scalars['String']['input']>;
  feedbackRating?: InputMaybe<Scalars['Boolean']['input']>;
  plannerVisitWorkerReportId: Scalars['ID']['input'];
  startFormConditions?: InputMaybe<Array<GqlPlannerVisitWeatherReportConditionInput>>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  stoppedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  submittedFormConditions?: InputMaybe<Array<GqlPlannerVisitWeatherReportConditionInput>>;
};

export type GqlPlannerVisitWeatherAutoValidationOverrideInput = {
  plannerVisitId: Scalars['ID']['input'];
  weatherProtocolAutoValidationOverriddenAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  weatherProtocolAutoValidationOverriddenReason?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPlannerVisitWeatherReport = {
  __typename: 'GqlPlannerVisitWeatherReport';
  conditions: Array<GqlPlannerVisitWeatherReportCondition>;
  sourceReportId: Scalars['String']['output'];
};

export type GqlPlannerVisitWeatherReportCondition = {
  __typename: 'GqlPlannerVisitWeatherReportCondition';
  endFormConditionKey?: Maybe<Scalars['String']['output']>;
  endFormOptions: Array<GqlSettingsFormTemplateQuestionSelectOption>;
  endKey?: Maybe<Scalars['String']['output']>;
  endLabel?: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  startFormConditionKey?: Maybe<Scalars['String']['output']>;
  startFormOptions: Array<GqlSettingsFormTemplateQuestionSelectOption>;
  startKey?: Maybe<Scalars['String']['output']>;
  startLabel?: Maybe<Scalars['String']['output']>;
};

export type GqlPlannerVisitWeatherReportConditionInput = {
  conditionKey: Scalars['String']['input'];
  optionKey: Scalars['String']['input'];
};

export type GqlPlannerVisitWorkerReportFilters = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  hasFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPriceEntry = {
  __typename: 'GqlPriceEntry';
  areaCount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  protocolName: Scalars['String']['output'];
  total: Scalars['String']['output'];
  travelCost: Scalars['String']['output'];
  travelTime: Scalars['String']['output'];
  workTime: Scalars['String']['output'];
};

export type GqlProject = {
  __typename: 'GqlProject';
  allowedActions: GqlProjectActions;
  client: GqlClient;
  clientId: Scalars['ID']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSpeciesManagementPlan: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  plannerAreas: Array<GqlPlannerArea>;
  showAllObservationsToClientUser: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  startAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status: GqlProjectStatus;
  travelAllowanceKms: Scalars['Int']['output'];
  travelAllowancePerKmInCents: Scalars['Int']['output'];
  travelAllowanceTimeInSeconds: Scalars['Int']['output'];
};

export type GqlProjectActions = {
  __typename: 'GqlProjectActions';
  changeStatus: ConditionalAction;
};

export type GqlProjectAutocompleteOption = {
  __typename: 'GqlProjectAutocompleteOption';
  clientId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GqlProjectCost = {
  __typename: 'GqlProjectCost';
  data: GqlCostSpec;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GqlProjectCostCreateInput = {
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};

export type GqlProjectCostGetAll = {
  __typename: 'GqlProjectCostGetAll';
  data: Array<GqlProjectCost>;
  queryInfo: GqlQueryInfo;
};

export type GqlProjectCostGetAllParams = {
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProjectCreateInput = {
  clientId: Scalars['ID']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  isSpeciesManagementPlan: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  showAllObservationsToClientUser: Scalars['Boolean']['input'];
  startAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status: GqlProjectStatus;
  travelAllowanceKms: Scalars['Int']['input'];
  travelAllowancePerKmInCents: Scalars['Int']['input'];
  travelAllowanceTimeInSeconds: Scalars['Int']['input'];
};

export type GqlProjectDeleteInput = {
  projectId: Scalars['ID']['input'];
};

export type GqlProjectExport = {
  __typename: 'GqlProjectExport';
  createdAt: Scalars['DateTimeISO']['output'];
  createdById: Scalars['ID']['output'];
  createdByUser: GqlUser;
  dataJobId?: Maybe<Scalars['String']['output']>;
  dataMediaItem?: Maybe<GqlMedia>;
  dataMediaItemId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mediaIncluded: Scalars['Boolean']['output'];
  mediaJobId?: Maybe<Scalars['String']['output']>;
  mediaMediaItem?: Maybe<GqlMedia>;
  mediaMediaItemId?: Maybe<Scalars['String']['output']>;
  projectIds: Array<Scalars['ID']['output']>;
  projects: Array<GqlProject>;
  researchTypeIds: Array<Scalars['ID']['output']>;
  researchTypes: Array<GqlSettingsResearchType>;
  template: GqlExportTemplate;
};

export type GqlProjectExportCreateInput = {
  clientId: Scalars['ID']['input'];
  mediaIncluded: Scalars['Boolean']['input'];
  projectIds: Array<Scalars['ID']['input']>;
  researchTypeIds: Array<Scalars['ID']['input']>;
  template: GqlExportTemplate;
};

export type GqlProjectExportDeleteInput = {
  projectExportId: Scalars['ID']['input'];
};

export type GqlProjectExportGetAllParams = {
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProjectExportGetAllPayload = {
  __typename: 'GqlProjectExportGetAllPayload';
  data: Array<GqlProjectExport>;
  queryInfo: GqlQueryInfo;
};

export type GqlProjectFunctionTypeFilter = {
  __typename: 'GqlProjectFunctionTypeFilter';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlProjectGetAllParams = {
  clientId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<GqlProjectStatus>>;
};

export type GqlProjectGetAllPayload = {
  __typename: 'GqlProjectGetAllPayload';
  data: Array<GqlProject>;
  queryInfo: GqlQueryInfo;
};

export type GqlProjectGetAutocompleteOptionsParams = {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<GqlProjectStatus>>;
};

export type GqlProjectGetAutocompleteOptionsPayload = {
  __typename: 'GqlProjectGetAutocompleteOptionsPayload';
  data: Array<GqlProjectAutocompleteOption>;
  selectedData: Array<GqlProjectAutocompleteOption>;
};

export type GqlProjectObservationTypeFilter = {
  __typename: 'GqlProjectObservationTypeFilter';
  label: Scalars['String']['output'];
  observationTypes: Array<GqlProjectObservationTypeItemFilter>;
  value: Scalars['String']['output'];
};

export type GqlProjectObservationTypeItemFilter = {
  __typename: 'GqlProjectObservationTypeItemFilter';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlProjectResearchTypeFilter = {
  __typename: 'GqlProjectResearchTypeFilter';
  label: Scalars['String']['output'];
  species: Array<GqlProjectResearchTypeSpeciesFilter>;
  value: Scalars['String']['output'];
};

export type GqlProjectResearchTypeSpeciesFilter = {
  __typename: 'GqlProjectResearchTypeSpeciesFilter';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlProjectRole = {
  __typename: 'GqlProjectRole';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissions: Array<ProjectPermission>;
};

export type GqlProjectStatistics = {
  __typename: 'GqlProjectStatistics';
  activeProtocols: Array<GqlProjectStatisticsActiveProtocolItem>;
  completedNumberOfVisits: Scalars['Int']['output'];
  completedVisitsPercentage: Scalars['Float']['output'];
  numberOfActiveProtocols: Scalars['Int']['output'];
  numberOfRecentlyFoundFunctions: Scalars['Int']['output'];
  projectId: Scalars['ID']['output'];
  recentlyApprovedPlannerVisits: Array<GqlPlannerV2Visit>;
  totalNumberOfAreas: Scalars['Int']['output'];
  totalNumberOfFunctions: Scalars['Int']['output'];
  totalNumberOfProtocols: Scalars['Int']['output'];
  totalNumberOfVisits: Scalars['Int']['output'];
  upcomingPlannerVisits: Array<GqlPlannerV2Visit>;
  visitStatusDistribution: Array<GqlProjectStatisticsVisitStatusDistributionItem>;
};

export type GqlProjectStatisticsActiveProtocolItem = {
  __typename: 'GqlProjectStatisticsActiveProtocolItem';
  completedNumberOfVisits: Scalars['Int']['output'];
  completedVisitsPercentage: Scalars['Float']['output'];
  protocol: GqlProtocol;
  protocolId: Scalars['ID']['output'];
  totalNumberOfAreas: Scalars['Int']['output'];
  totalNumberOfVisits: Scalars['Int']['output'];
};

export type GqlProjectStatisticsVisitStatusDistributionItem = {
  __typename: 'GqlProjectStatisticsVisitStatusDistributionItem';
  count: Scalars['Int']['output'];
  status: GqlPlannerV2VisitSimplifiedStatus;
};

/** Project status */
export enum GqlProjectStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Confirmed = 'confirmed',
  Open = 'open'
}

/** Project types */
export enum GqlProjectType {
  SpeciesResearch = 'speciesResearch'
}

export type GqlProjectUpdateInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  isSpeciesManagementPlan: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  showAllObservationsToClientUser: Scalars['Boolean']['input'];
  startAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status: GqlProjectStatus;
  travelAllowanceKms: Scalars['Int']['input'];
  travelAllowancePerKmInCents: Scalars['Int']['input'];
  travelAllowanceTimeInSeconds: Scalars['Int']['input'];
};

export type GqlProjectUser = {
  __typename: 'GqlProjectUser';
  id: Scalars['ID']['output'];
  project: GqlProject;
  projectId: Scalars['ID']['output'];
  projectRole?: Maybe<GqlProjectRole>;
  roleId: Scalars['ID']['output'];
  user: GqlUser;
  userId: Scalars['ID']['output'];
};

export type GqlProjectUserAssignRoleInput = {
  projectId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GqlProjectUserDeleteInput = {
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GqlProjectUserGetAllPayload = {
  __typename: 'GqlProjectUserGetAllPayload';
  data: Array<GqlProjectUser>;
  queryInfo: GqlQueryInfo;
};

export type GqlProjectUserGetAllProjectsParams = {
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProjectUserGetAllUsersParams = {
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  projectId: Scalars['String']['input'];
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProjectUserInviteInput = {
  email: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};

export type GqlProtocol = {
  __typename: 'GqlProtocol';
  collectAllMediaPoints: Scalars['Boolean']['output'];
  courses: Array<GqlCourse>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  possibleVisitDays: Scalars['JSON']['output'];
  requiresRouteShuffling: Scalars['Boolean']['output'];
  researchType: GqlSettingsResearchType;
  researchTypeId: Scalars['String']['output'];
  templateProtocolId?: Maybe<Scalars['String']['output']>;
  visits: Array<GqlProtocolVisit>;
};

export type GqlProtocolGetAll = {
  __typename: 'GqlProtocolGetAll';
  data: Array<GqlProtocol>;
  queryInfo: GqlQueryInfo;
};

export type GqlProtocolGetAllParams = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  templates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlProtocolVisit = {
  __typename: 'GqlProtocolVisit';
  calculateTravelCost: Scalars['Boolean']['output'];
  condition: Scalars['GqlJSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxPrecipitation: Scalars['Float']['output'];
  maxTemperature: Scalars['Float']['output'];
  maxWindForce: Scalars['Float']['output'];
  minDurationInSeconds: Scalars['Int']['output'];
  minTemperature: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['Float']['output'];
  pricePerHourInCents: Scalars['Int']['output'];
  timeslots?: Maybe<Scalars['GqlJSON']['output']>;
};

export type GqlQueryInfo = {
  __typename: 'GqlQueryInfo';
  filterOptions?: Maybe<Array<GqlFilterOption>>;
  paginationOption: GqlPaginationOption;
  sortableColumns: Array<Scalars['String']['output']>;
};

export type GqlReportsBulkUpdateApprovalForPlannerVisitInput = {
  plannerVisitId: Scalars['ID']['input'];
  status: GqlWorkerVisitReportStatus;
};

export type GqlSettingsEcologicalFunctionType = {
  __typename: 'GqlSettingsEcologicalFunctionType';
  description?: Maybe<Scalars['String']['output']>;
  featureType: GqlFeatureType;
  formTemplate: GqlSettingsFormTemplate;
  formTemplateId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isEssential: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  mapIcon: GqlMapShapeIcon;
  name: Scalars['String']['output'];
  observationTypes: Array<GqlSettingsObservationType>;
  order: Scalars['Int']['output'];
  researchTypeId: Scalars['ID']['output'];
};

export type GqlSettingsEcologicalFunctionTypeCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  featureType: GqlFeatureType;
  isEssential: Scalars['Boolean']['input'];
  mapIcon: GqlMapShapeIcon;
  name: Scalars['String']['input'];
  researchTypeId: Scalars['ID']['input'];
};

export type GqlSettingsEcologicalFunctionTypeDeleteInput = {
  ecologicalFunctionTypeId: Scalars['ID']['input'];
};

export type GqlSettingsEcologicalFunctionTypeGetAllAssignableParams = {
  observationTypeId: Scalars['ID']['input'];
  researchTypeId: Scalars['ID']['input'];
};

export type GqlSettingsEcologicalFunctionTypeObservationTypeLinkInput = {
  ecologicalFunctionTypeId: Scalars['ID']['input'];
  observationTypeId: Scalars['ID']['input'];
};

export type GqlSettingsEcologicalFunctionTypeObservationTypeUnlinkInput = {
  ecologicalFunctionTypeId: Scalars['ID']['input'];
  observationTypeId: Scalars['ID']['input'];
};

export type GqlSettingsEcologicalFunctionTypeUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  ecologicalFunctionTypeId: Scalars['ID']['input'];
  featureType: GqlFeatureType;
  isEssential: Scalars['Boolean']['input'];
  mapIcon: GqlMapShapeIcon;
  name: Scalars['String']['input'];
};

export type GqlSettingsFormTemplate = {
  __typename: 'GqlSettingsFormTemplate';
  deprecatedQuestions: Array<GqlSettingsFormTemplateQuestion>;
  id: Scalars['ID']['output'];
  questions: Array<GqlSettingsFormTemplateQuestion>;
};


export type GqlSettingsFormTemplateQuestionsArgs = {
  skipDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skipWeatherRelated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Master forms available in the application */
export enum GqlSettingsFormTemplateMasterFormType {
  PreciseLocation = 'PreciseLocation',
  StartVisit = 'StartVisit',
  StopVisit = 'StopVisit',
  SubmitVisit = 'SubmitVisit'
}

export type GqlSettingsFormTemplateQuestion = {
  __typename: 'GqlSettingsFormTemplateQuestion';
  condition: GqlSettingsFormTemplateQuestionCondition;
  defaultValue?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  formTemplateId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  showToClientUser: Scalars['Boolean']['output'];
  tags?: Maybe<Array<GqlSettingsFormTemplateQuestionTag>>;
  type: GqlSettingsFormTemplateQuestionType;
};

export type GqlSettingsFormTemplateQuestionCondition = GqlSettingsFormTemplateQuestionConditionIsEqual | GqlSettingsFormTemplateQuestionConditionNone | GqlSettingsFormTemplateQuestionConditionOr;

export type GqlSettingsFormTemplateQuestionConditionIsEqual = {
  __typename: 'GqlSettingsFormTemplateQuestionConditionIsEqual';
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlSettingsFormTemplateQuestionConditionNone = {
  __typename: 'GqlSettingsFormTemplateQuestionConditionNone';
  id: Scalars['String']['output'];
};

export type GqlSettingsFormTemplateQuestionConditionOr = {
  __typename: 'GqlSettingsFormTemplateQuestionConditionOr';
  conditions: Array<GqlSettingsFormTemplateQuestionConditionIsEqual>;
  id: Scalars['String']['output'];
};

export type GqlSettingsFormTemplateQuestionCreateInput = {
  condition: Scalars['GqlJSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  formTemplateId: Scalars['ID']['input'];
  isRequired: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  showToClientUser: Scalars['Boolean']['input'];
  tags?: InputMaybe<Array<GqlSettingsFormTemplateQuestionTag>>;
  type: Scalars['GqlJSON']['input'];
};

export type GqlSettingsFormTemplateQuestionDeleteInput = {
  formTemplateQuestionId: Scalars['ID']['input'];
};

export type GqlSettingsFormTemplateQuestionSelectOption = {
  __typename: 'GqlSettingsFormTemplateQuestionSelectOption';
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum GqlSettingsFormTemplateQuestionTag {
  Cloudiness = 'cloudiness',
  Precipitation = 'precipitation',
  SizingEstimate = 'sizingEstimate',
  SizingEstimateFemale = 'sizingEstimateFemale',
  SizingEstimateMale = 'sizingEstimateMale',
  SummaryInfo = 'summaryInfo',
  Temperature = 'temperature',
  WeatherInfo = 'weatherInfo',
  WindDirection = 'windDirection',
  WindForce = 'windForce'
}

export type GqlSettingsFormTemplateQuestionType = GqlSettingsFormTemplateQuestionTypeAmount | GqlSettingsFormTemplateQuestionTypeDateTime | GqlSettingsFormTemplateQuestionTypeDropdown | GqlSettingsFormTemplateQuestionTypeRecording | GqlSettingsFormTemplateQuestionTypeSelect | GqlSettingsFormTemplateQuestionTypeText;

export type GqlSettingsFormTemplateQuestionTypeAmount = {
  __typename: 'GqlSettingsFormTemplateQuestionTypeAmount';
  id: Scalars['String']['output'];
};

export type GqlSettingsFormTemplateQuestionTypeDateTime = {
  __typename: 'GqlSettingsFormTemplateQuestionTypeDateTime';
  id: Scalars['String']['output'];
};

export type GqlSettingsFormTemplateQuestionTypeDropdown = {
  __typename: 'GqlSettingsFormTemplateQuestionTypeDropdown';
  id: Scalars['String']['output'];
  options: Array<GqlSettingsFormTemplateQuestionSelectOption>;
};

export type GqlSettingsFormTemplateQuestionTypeRecording = {
  __typename: 'GqlSettingsFormTemplateQuestionTypeRecording';
  id: Scalars['String']['output'];
};

export type GqlSettingsFormTemplateQuestionTypeSelect = {
  __typename: 'GqlSettingsFormTemplateQuestionTypeSelect';
  id: Scalars['String']['output'];
  options: Array<GqlSettingsFormTemplateQuestionSelectOption>;
};

export type GqlSettingsFormTemplateQuestionTypeText = {
  __typename: 'GqlSettingsFormTemplateQuestionTypeText';
  id: Scalars['String']['output'];
  multiline: Scalars['Boolean']['output'];
};

export type GqlSettingsFormTemplateQuestionUpdateInput = {
  condition: Scalars['GqlJSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  formTemplateQuestionId: Scalars['ID']['input'];
  isRequired: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  showToClientUser: Scalars['Boolean']['input'];
  tags?: InputMaybe<Array<GqlSettingsFormTemplateQuestionTag>>;
  type: Scalars['GqlJSON']['input'];
};

export type GqlSettingsObservationType = {
  __typename: 'GqlSettingsObservationType';
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ecologicalFunctionTypes: Array<GqlSettingsEcologicalFunctionType>;
  featureType: GqlFeatureType;
  formTemplate: GqlSettingsFormTemplate;
  formTemplateId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  requireMediaItems: Scalars['Boolean']['output'];
  requirePreciseLocation: Scalars['Boolean']['output'];
  researchType: GqlSettingsResearchType;
  researchTypeId: Scalars['ID']['output'];
  showToClientUser: Scalars['Boolean']['output'];
};

export type GqlSettingsObservationTypeCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  featureType: GqlFeatureType;
  name: Scalars['String']['input'];
  researchTypeId: Scalars['ID']['input'];
  showToClientUser: Scalars['Boolean']['input'];
};

export type GqlSettingsObservationTypeDeleteInput = {
  observationTypeId: Scalars['ID']['input'];
};

export type GqlSettingsObservationTypeGetAllAssignableParams = {
  ecologicalFunctionTypeId: Scalars['ID']['input'];
  researchTypeId: Scalars['ID']['input'];
};

export type GqlSettingsObservationTypeUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  featureType: GqlFeatureType;
  name: Scalars['String']['input'];
  observationTypeId: Scalars['ID']['input'];
  requireMediaItems: Scalars['Boolean']['input'];
  requirePreciseLocation: Scalars['Boolean']['input'];
  showToClientUser: Scalars['Boolean']['input'];
};

export type GqlSettingsResearchType = {
  __typename: 'GqlSettingsResearchType';
  description?: Maybe<Scalars['String']['output']>;
  ecologicalFunctionTypes: Array<GqlSettingsEcologicalFunctionType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  observationTypes: Array<GqlSettingsObservationType>;
  requireRecordings: Scalars['Boolean']['output'];
  species: Array<GqlSettingsSpecies>;
  speciesV2: Array<GqlSettingsResearchTypeSpecies>;
  submitForm: GqlSettingsFormTemplate;
  submitFormId: Scalars['ID']['output'];
  visitSummaryTemplate?: Maybe<Scalars['GqlJSON']['output']>;
};

export type GqlSettingsResearchTypeCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  requireRecordings: Scalars['Boolean']['input'];
  speciesIds: Array<Scalars['String']['input']>;
};

export type GqlSettingsResearchTypeDeleteInput = {
  researchTypeId: Scalars['ID']['input'];
};

export type GqlSettingsResearchTypeGetAllParams = {
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSettingsResearchTypeGetAutocompleteOptionsPayload = {
  __typename: 'GqlSettingsResearchTypeGetAutocompleteOptionsPayload';
  data: Array<GqlAutocompleteOption>;
};

export type GqlSettingsResearchTypeSpecies = {
  __typename: 'GqlSettingsResearchTypeSpecies';
  id: Scalars['ID']['output'];
  researchType: GqlSettingsResearchType;
  researchTypeId: Scalars['ID']['output'];
  showToClientUser: Scalars['Boolean']['output'];
  species: GqlSettingsSpecies;
  speciesId: Scalars['ID']['output'];
};

export type GqlSettingsResearchTypeSpeciesCreateInput = {
  researchTypeId: Scalars['ID']['input'];
  showToClientUser: Scalars['Boolean']['input'];
  speciesId: Scalars['ID']['input'];
};

export type GqlSettingsResearchTypeSpeciesDeleteInput = {
  researchTypeId: Scalars['ID']['input'];
  speciesId: Scalars['ID']['input'];
};

export type GqlSettingsResearchTypeSpeciesUpdateShowToClientUserInput = {
  researchTypeId: Scalars['ID']['input'];
  showToClientUser: Scalars['Boolean']['input'];
  speciesId: Scalars['ID']['input'];
};

export type GqlSettingsResearchTypeUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  requireRecordings: Scalars['Boolean']['input'];
  researchTypeId: Scalars['ID']['input'];
};

export type GqlSettingsSpecies = {
  __typename: 'GqlSettingsSpecies';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRareSpecies: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  mapColor: Scalars['String']['output'];
  name: Scalars['String']['output'];
  scientificName: Scalars['String']['output'];
};

export type GqlSettingsSpeciesCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isRareSpecies?: InputMaybe<Scalars['Boolean']['input']>;
  mapColor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  scientificName: Scalars['String']['input'];
};

export type GqlSettingsSpeciesDeleteInput = {
  speciesId: Scalars['ID']['input'];
};

export type GqlSettingsSpeciesGetAllParams = {
  excludeAssignedToResearchTypeId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSettingsSpeciesUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isRareSpecies: Scalars['Boolean']['input'];
  mapColor: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scientificName: Scalars['String']['input'];
  speciesId: Scalars['ID']['input'];
};

export type GqlSettingsVisitSummaryTemplateUpdateInput = {
  researchTypeId: Scalars['ID']['input'];
  template?: InputMaybe<Scalars['GqlJSON']['input']>;
};

export type GqlSpeciesGetAutocompleteOptionsParams = {
  excludeAssignedToResearchTypeId?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlSpeciesGetAutocompleteOptionsPayload = {
  __typename: 'GqlSpeciesGetAutocompleteOptionsPayload';
  data: Array<GqlAutocompleteOption>;
  selectedData: Array<GqlAutocompleteOption>;
};

export type GqlSpeciesResearchCostSpec = {
  __typename: 'GqlSpeciesResearchCostSpec';
  prices: Array<GqlPriceEntry>;
  protocols: Array<GqlCostSpecProtocol>;
  subTotal: Scalars['String']['output'];
  total: Scalars['String']['output'];
  travelCost: Scalars['String']['output'];
  travelDistance: Scalars['String']['output'];
  travelDuration: Scalars['String']['output'];
  type: GqlProjectType;
  vat: Scalars['String']['output'];
};

export type GqlTenant = {
  __typename: 'GqlTenant';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  userImportJobId?: Maybe<Scalars['String']['output']>;
};

export type GqlTenantRole = {
  __typename: 'GqlTenantRole';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<GqlPermissions>;
};

export type GqlUploadableMedia = {
  __typename: 'GqlUploadableMedia';
  id: Scalars['ID']['output'];
  isUploaded: Scalars['Boolean']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  uploadUrl: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlUser = {
  __typename: 'GqlUser';
  email: Scalars['String']['output'];
  externalReference?: Maybe<Scalars['String']['output']>;
  fieldworker?: Maybe<GqlFieldworker>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  profilePictureId?: Maybe<Scalars['String']['output']>;
  profilePictureMedia?: Maybe<GqlMedia>;
  tenantRole?: Maybe<GqlTenantRole>;
  userCourses: Array<GqlCourse>;
};

export type GqlUserCreateInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

export type GqlUserDeleteCourseInput = {
  courseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GqlUserDeleteInput = {
  userId: Scalars['ID']['input'];
};

export type GqlUserGetAll = {
  __typename: 'GqlUserGetAll';
  data: Array<GqlUser>;
  queryInfo: GqlQueryInfo;
};

export type GqlUserGetAllParams = {
  courseId?: InputMaybe<Array<Scalars['String']['input']>>;
  finishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveFieldworker?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  transportation?: InputMaybe<Array<GqlFieldworkerTransportationMethod>>;
};

export type GqlUserLoginPayload = {
  __typename: 'GqlUserLoginPayload';
  deviceId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  jwt: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type GqlUserRecoverPasswordInput = {
  email: Scalars['String']['input'];
};

export type GqlUserResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type GqlUserStartImportInput = {
  mediaId: Scalars['ID']['input'];
};

export type GqlUserUpdateDevicePushTokenInput = {
  deviceId: Scalars['String']['input'];
  pushToken?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUserUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  passwordData?: InputMaybe<GqlUserUpdatePasswordInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profilePictureId?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type GqlUserUpdatePasswordInput = {
  confirmNewPassword: Scalars['String']['input'];
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
};

export enum GqlWorkerVisitReportStatus {
  Approved = 'approved',
  AwaitingApproval = 'awaitingApproval',
  AwaitingReport = 'awaitingReport',
  Rejected = 'rejected'
}

export type MapEditorOtherFeatureCreateInput = {
  geometry: Scalars['GqlJSON']['input'];
  mapEditorLayerId: Scalars['String']['input'];
};

export type Mutation = {
  __typename: 'Mutation';
  appEventBatchCreate: GqlEventBatch;
  clientCreate: GqlClient;
  clientDelete: Scalars['Boolean']['output'];
  clientUpdate: GqlClient;
  clientUserDelete: Scalars['Boolean']['output'];
  clientUserInvite: GqlClientUser;
  courseAddToUser: GqlUser;
  courseCreate: GqlCourseCreatePayload;
  courseDelete: GqlCourseDeletePayload;
  courseUpdate: GqlCourseUpdatePayload;
  ecologicalFunctionCreate: GqlEcologicalFunction;
  ecologicalFunctionObservationCreate: GqlEcologicalFunction;
  ecologicalFunctionObservationDelete: GqlEcologicalFunction;
  ecologicalFunctionUpdate: GqlEcologicalFunction;
  fieldworkerCreate: GqlFieldworker;
  fieldworkerFinishOnboarding: GqlFieldworker;
  fieldworkerPaymentCreate: GqlFieldworkerPayment;
  fieldworkerUpdate: GqlFieldworker;
  fieldworkerUpdateAvailability: Scalars['Boolean']['output'];
  invoiceCreate: GqlInvoice;
  invoiceExportToCsv: GqlInvoiceCsvExport;
  mapEditorFeatureDelete: Scalars['Boolean']['output'];
  mapEditorFeatureImportStart: GqlMapEditorFeatureImportJob;
  mapEditorFeatureUpdate: GqlMapEditorGeoJsonFeature;
  mapEditorLayerCreate: GqlMapEditorLayer;
  mapEditorLayerCreateFromFile: GqlJob;
  mapEditorLayerDelete: Scalars['Boolean']['output'];
  mapEditorLayerUpdate: GqlMapEditorLayer;
  mapEditorOtherFeatureCreate: GqlMapEditorFeature;
  mediaCreate: GqlUploadableMedia;
  mediaCreateUploadable: GqlUploadableMedia;
  mediaSetUploaded: GqlMedia;
  mediaUpdateStatus: GqlMedia;
  notificationCreate: GqlNotification;
  notificationUpdateIsRead: Scalars['Boolean']['output'];
  observationAddMediaPoint: GqlObservation;
  observationChangeStatus: GqlObservation;
  observationClone: GqlObservation;
  observationCreate: GqlObservation;
  observationDeleteMediaPoint: GqlObservation;
  observationEcologicalFunctionCreate: GqlObservation;
  observationEcologicalFunctionDelete: GqlObservation;
  observationMediaPointUpdate: GqlMediaPoint;
  observationUpdate: GqlObservation;
  observationsBulkApproveByVisit: Scalars['Boolean']['output'];
  plannerAreaMediaAddMedia: Scalars['Boolean']['output'];
  plannerAreaMediaRemoveMedia: Scalars['Boolean']['output'];
  plannerAreaRemoveProtocol: Scalars['Boolean']['output'];
  plannerAreaSaveProtocol: Scalars['Boolean']['output'];
  plannerAreaUpdate: GqlPlannerArea;
  plannerV2FieldworkerMergePickupDropoffLocation: GqlPlannerV2TravelGroup;
  plannerV2FieldworkerMovePickupDropoffLocation: GqlPlannerV2TravelGroup;
  plannerV2FieldworkerRemovePickupDropoffLocation: GqlPlannerV2TravelGroup;
  plannerV2PlannerAreaCreate: GqlPlannerV2Area;
  plannerV2ScheduleCancel: Scalars['Boolean']['output'];
  plannerV2ScheduleConfirm: Scalars['Boolean']['output'];
  plannerV2ShiftCreateFromVisit: GqlPlannerV2Shift;
  plannerV2ShiftMarkReadyForPayment: GqlPlannerV2Shift;
  plannerV2TravelGroupAddFieldworker: GqlPlannerV2TravelGroup;
  plannerV2TravelGroupAddVisit: GqlPlannerV2TravelGroup;
  plannerV2TravelGroupCancel: Scalars['Boolean']['output'];
  plannerV2TravelGroupCancelShift: GqlPlannerV2TravelGroup;
  plannerV2TravelGroupRemoveVisit: GqlPlannerV2TravelGroup;
  plannerV2VisitChangeTeamCaptain: GqlPlannerV2Visit;
  plannerV2VisitDelete: GqlPlannerV2Visit;
  plannerV2VisitSetRequiredFieldworkers: Scalars['Boolean']['output'];
  plannerVisitApprove: Scalars['Boolean']['output'];
  plannerVisitOverrideTimeAutoValidation: GqlPlannerV2Visit;
  plannerVisitOverrideWeatherAutoValidation: GqlPlannerV2Visit;
  plannerVisitRecalculateDays: Scalars['Boolean']['output'];
  plannerVisitRegenerateSummary: GqlPlannerVisitSummaryRegeneratePayload;
  plannerVisitReject: Scalars['Boolean']['output'];
  plannerVisitV2ReportsUpdateStatus: GqlPlannerV2Visit;
  plannerVisitV2WorkerReportUpdate: GqlPlannerVisitV2WorkerReport;
  projectCostCreate: GqlProjectCost;
  projectCreate: GqlProject;
  projectDelete: Scalars['Boolean']['output'];
  projectExportCreate: GqlProjectExport;
  projectExportDelete: Scalars['Boolean']['output'];
  projectUpdate: GqlProject;
  projectUserAssignRole: GqlProjectUser;
  projectUserDelete: Scalars['Boolean']['output'];
  projectUserInvite: GqlProjectUser;
  protocolCourseCreate: GqlProtocol;
  protocolCourseDelete: GqlProtocol;
  protocolCreate: GqlProtocol;
  protocolDelete: GqlProtocol;
  protocolUpdate: GqlProtocol;
  protocolVisitCreate: GqlProtocolVisit;
  protocolVisitDelete: GqlProtocolVisit;
  protocolVisitUpdate: GqlProtocolVisit;
  settingsEcologicalFunctionTypeCreate: GqlSettingsEcologicalFunctionType;
  settingsEcologicalFunctionTypeDelete: Scalars['Boolean']['output'];
  settingsEcologicalFunctionTypeObservationTypeCreate: GqlSettingsEcologicalFunctionType;
  settingsEcologicalFunctionTypeObservationTypeDelete: GqlSettingsEcologicalFunctionType;
  settingsEcologicalFunctionTypeUpdate: GqlSettingsEcologicalFunctionType;
  settingsFormTemplateQuestionCreate: GqlSettingsFormTemplateQuestion;
  settingsFormTemplateQuestionDelete: Scalars['Boolean']['output'];
  settingsFormTemplateQuestionUpdate: GqlSettingsFormTemplateQuestion;
  settingsObservationTypeCreate: GqlSettingsObservationType;
  settingsObservationTypeDelete: Scalars['Boolean']['output'];
  settingsObservationTypeEcologicalFunctionTypeCreate: GqlSettingsObservationType;
  settingsObservationTypeEcologicalFunctionTypeDelete: GqlSettingsObservationType;
  settingsObservationTypeUpdate: GqlSettingsObservationType;
  settingsResearchTypeCreate: GqlSettingsResearchType;
  settingsResearchTypeDelete: Scalars['Boolean']['output'];
  settingsResearchTypeSpeciesCreate: GqlSettingsResearchType;
  settingsResearchTypeSpeciesDelete: GqlSettingsResearchType;
  settingsResearchTypeSpeciesUpdateShowToClientUser: GqlSettingsResearchType;
  settingsResearchTypeUpdate: GqlSettingsResearchType;
  settingsSpeciesCreate: GqlSettingsSpecies;
  settingsSpeciesDelete: Scalars['Boolean']['output'];
  settingsSpeciesUpdate: GqlSettingsSpecies;
  settingsVisitSummaryTemplateUpdate: GqlSettingsResearchType;
  userCourseDelete: GqlUser;
  userCreate: GqlUser;
  userDelete: Scalars['Boolean']['output'];
  userImportStart: GqlJob;
  userLogin: GqlUserLoginPayload;
  userLogout: Scalars['Boolean']['output'];
  userRecoverPassword: Scalars['Boolean']['output'];
  userRefreshSession: GqlUserLoginPayload;
  userResetPassword: Scalars['Boolean']['output'];
  userUpdate: GqlUser;
  userUpdatePushTokenMutation: Scalars['Boolean']['output'];
};


export type MutationAppEventBatchCreateArgs = {
  data: GqlAppEventBatchCreateData;
};


export type MutationClientCreateArgs = {
  input: GqlClientCreateInput;
};


export type MutationClientDeleteArgs = {
  input: GqlClientDeleteInput;
};


export type MutationClientUpdateArgs = {
  input: GqlClientUpdateInput;
};


export type MutationClientUserDeleteArgs = {
  input: GqlClientUserDeleteInput;
};


export type MutationClientUserInviteArgs = {
  input: GqlClientUserInviteInput;
};


export type MutationCourseAddToUserArgs = {
  input: GqlCourseAddToUserInput;
};


export type MutationCourseCreateArgs = {
  input: GqlCourseCreateInput;
};


export type MutationCourseDeleteArgs = {
  input: GqlCourseDeleteInput;
};


export type MutationCourseUpdateArgs = {
  input: GqlCourseUpdateInput;
};


export type MutationEcologicalFunctionCreateArgs = {
  input: GqlEcologicalFunctionCreateInput;
};


export type MutationEcologicalFunctionObservationCreateArgs = {
  input: GqlEcologicalFunctionToObservationLinkInput;
};


export type MutationEcologicalFunctionObservationDeleteArgs = {
  input: GqlEcologicalFunctionToObservationUnlinkInput;
};


export type MutationEcologicalFunctionUpdateArgs = {
  input: GqlEcologicalFunctionUpdateInput;
};


export type MutationFieldworkerCreateArgs = {
  input: GqlFieldworkerCreateInput;
};


export type MutationFieldworkerFinishOnboardingArgs = {
  input: GqlFieldworkerFinishOnboardingInput;
};


export type MutationFieldworkerPaymentCreateArgs = {
  input: GqlFieldworkerPaymentCreateInput;
};


export type MutationFieldworkerUpdateArgs = {
  input: GqlFieldworkerUpdateInput;
};


export type MutationFieldworkerUpdateAvailabilityArgs = {
  input: GqlFieldworkerUpdateAvailabilityInput;
};


export type MutationInvoiceCreateArgs = {
  input: GqlInvoiceCreateInput;
};


export type MutationInvoiceExportToCsvArgs = {
  input: GqlInvoiceExportToCsvInput;
};


export type MutationMapEditorFeatureDeleteArgs = {
  input: GqlMapEditorFeatureDeleteInput;
};


export type MutationMapEditorFeatureImportStartArgs = {
  input: GqlMapEditorFeatureStartImportInput;
};


export type MutationMapEditorFeatureUpdateArgs = {
  input: GqlMapEditorFeatureUpdateInput;
};


export type MutationMapEditorLayerCreateArgs = {
  input: GqlMapEditorLayerCreateInput;
};


export type MutationMapEditorLayerCreateFromFileArgs = {
  input: GqlMapEditorLayerStartImportInput;
};


export type MutationMapEditorLayerDeleteArgs = {
  input: GqlMapEditorLayerDeleteInput;
};


export type MutationMapEditorLayerUpdateArgs = {
  input: GqlMapEditorLayerUpdateInput;
};


export type MutationMapEditorOtherFeatureCreateArgs = {
  input: MapEditorOtherFeatureCreateInput;
};


export type MutationMediaCreateArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationMediaCreateUploadableArgs = {
  input: GqlMediaCreateInput;
};


export type MutationMediaSetUploadedArgs = {
  input: GqlMediaSetUploadedInput;
};


export type MutationMediaUpdateStatusArgs = {
  mediaId: Scalars['String']['input'];
};


export type MutationNotificationCreateArgs = {
  input: GqlNotificationCreateInput;
};


export type MutationNotificationUpdateIsReadArgs = {
  input: GqlNotificationMarkAsReadInput;
};


export type MutationObservationAddMediaPointArgs = {
  input: GqlObservationAddMediaPointInput;
};


export type MutationObservationChangeStatusArgs = {
  input: GqlObservationStatusChangeInput;
};


export type MutationObservationCloneArgs = {
  input: GqlObservationCloneInput;
};


export type MutationObservationCreateArgs = {
  input: ObservationCreateInput;
};


export type MutationObservationDeleteMediaPointArgs = {
  input: GqlObservationDeleteMediaPointInput;
};


export type MutationObservationEcologicalFunctionCreateArgs = {
  input: GqlEcologicalFunctionToObservationLinkInput;
};


export type MutationObservationEcologicalFunctionDeleteArgs = {
  input: GqlEcologicalFunctionToObservationUnlinkInput;
};


export type MutationObservationMediaPointUpdateArgs = {
  input: GqlObservationMediaPointUpdateInput;
};


export type MutationObservationUpdateArgs = {
  input: GqlObservationUpdateInput;
};


export type MutationObservationsBulkApproveByVisitArgs = {
  input: GqlObservationsBulkApproveByVisitInput;
};


export type MutationPlannerAreaMediaAddMediaArgs = {
  input: GqlPlannerAreaMediaAddInput;
};


export type MutationPlannerAreaMediaRemoveMediaArgs = {
  input: GqlPlannerAreaMediaRemoveInput;
};


export type MutationPlannerAreaRemoveProtocolArgs = {
  input: GqlPlannerAreaRemoveProtocolInput;
};


export type MutationPlannerAreaSaveProtocolArgs = {
  input: GqlPlannerAreaSaveProtocolInput;
};


export type MutationPlannerAreaUpdateArgs = {
  input: GqlPlannerAreaUpdateInput;
};


export type MutationPlannerV2FieldworkerMergePickupDropoffLocationArgs = {
  input: GqlPlannerV2FieldworkerMergePickupDropoffLocationInput;
};


export type MutationPlannerV2FieldworkerMovePickupDropoffLocationArgs = {
  input: GqlPlannerV2FieldworkerMovePickupDropoffLocationInput;
};


export type MutationPlannerV2FieldworkerRemovePickupDropoffLocationArgs = {
  input: GqlPlannerV2FieldworkerRemovePickupDropoffLocationInput;
};


export type MutationPlannerV2PlannerAreaCreateArgs = {
  input: PlannerAreaCreateInput;
};


export type MutationPlannerV2ScheduleCancelArgs = {
  input?: InputMaybe<GqlPlannerV2ScheduleCancelInput>;
};


export type MutationPlannerV2ScheduleConfirmArgs = {
  input?: InputMaybe<GqlPlannerV2ScheduleConfirmInput>;
};


export type MutationPlannerV2ShiftCreateFromVisitArgs = {
  input: GqlPlannerV2ShiftCreateFromVisitInput;
};


export type MutationPlannerV2ShiftMarkReadyForPaymentArgs = {
  input: GqlPlannerV2ShiftMarkReadyForPaymentInput;
};


export type MutationPlannerV2TravelGroupAddFieldworkerArgs = {
  input: GqlPlannerV2TravelGroupAddFieldworkerInput;
};


export type MutationPlannerV2TravelGroupAddVisitArgs = {
  input: GqlPlannerV2TravelGroupAddVisitInput;
};


export type MutationPlannerV2TravelGroupCancelArgs = {
  input: GqlPlannerV2TravelGroupCancelInput;
};


export type MutationPlannerV2TravelGroupCancelShiftArgs = {
  input: GqlPlannerV2TravelGroupCancelShift;
};


export type MutationPlannerV2TravelGroupRemoveVisitArgs = {
  input: GqlPlannerV2TravelGroupRemoveVisitInput;
};


export type MutationPlannerV2VisitChangeTeamCaptainArgs = {
  input: GqlPlannerV2VisitChangeTeamCaptainInput;
};


export type MutationPlannerV2VisitDeleteArgs = {
  input: GqlPlannerV2VisitDeleteInput;
};


export type MutationPlannerV2VisitSetRequiredFieldworkersArgs = {
  input: GqlPlannerV2VisitSetRequiredFieldworkersInput;
};


export type MutationPlannerVisitApproveArgs = {
  plannerVisitId: Scalars['ID']['input'];
};


export type MutationPlannerVisitOverrideTimeAutoValidationArgs = {
  input: GqlPlannerVisitTimeAutoValidationOverrideInput;
};


export type MutationPlannerVisitOverrideWeatherAutoValidationArgs = {
  input: GqlPlannerVisitWeatherAutoValidationOverrideInput;
};


export type MutationPlannerVisitRegenerateSummaryArgs = {
  input: GqlPlannerVisitSummaryRegenerateInput;
};


export type MutationPlannerVisitRejectArgs = {
  plannerVisitId: Scalars['ID']['input'];
  rejectionReason: Scalars['String']['input'];
};


export type MutationPlannerVisitV2ReportsUpdateStatusArgs = {
  input: GqlReportsBulkUpdateApprovalForPlannerVisitInput;
};


export type MutationPlannerVisitV2WorkerReportUpdateArgs = {
  input: GqlPlannerVisitV2WorkerReportUpdateInput;
};


export type MutationProjectCostCreateArgs = {
  input: GqlProjectCostCreateInput;
};


export type MutationProjectCreateArgs = {
  input: GqlProjectCreateInput;
};


export type MutationProjectDeleteArgs = {
  input: GqlProjectDeleteInput;
};


export type MutationProjectExportCreateArgs = {
  input: GqlProjectExportCreateInput;
};


export type MutationProjectExportDeleteArgs = {
  input: GqlProjectExportDeleteInput;
};


export type MutationProjectUpdateArgs = {
  input: GqlProjectUpdateInput;
};


export type MutationProjectUserAssignRoleArgs = {
  input: GqlProjectUserAssignRoleInput;
};


export type MutationProjectUserDeleteArgs = {
  input: GqlProjectUserDeleteInput;
};


export type MutationProjectUserInviteArgs = {
  input: GqlProjectUserInviteInput;
};


export type MutationProtocolCourseCreateArgs = {
  input: ProtocolCourseCreateInput;
};


export type MutationProtocolCourseDeleteArgs = {
  input: ProtocolCourseDeleteInput;
};


export type MutationProtocolCreateArgs = {
  input: ProtocolCreateInput;
};


export type MutationProtocolDeleteArgs = {
  input: ProtocolDeleteInput;
};


export type MutationProtocolUpdateArgs = {
  input: ProtocolUpdateInput;
};


export type MutationProtocolVisitCreateArgs = {
  input: ProtocolAddProtocolVisitInput;
};


export type MutationProtocolVisitDeleteArgs = {
  input: ProtocolVisitDeleteInput;
};


export type MutationProtocolVisitUpdateArgs = {
  input: ProtocolUpdateProtocolVisitInput;
};


export type MutationSettingsEcologicalFunctionTypeCreateArgs = {
  input: GqlSettingsEcologicalFunctionTypeCreateInput;
};


export type MutationSettingsEcologicalFunctionTypeDeleteArgs = {
  input: GqlSettingsEcologicalFunctionTypeDeleteInput;
};


export type MutationSettingsEcologicalFunctionTypeObservationTypeCreateArgs = {
  input: GqlSettingsEcologicalFunctionTypeObservationTypeLinkInput;
};


export type MutationSettingsEcologicalFunctionTypeObservationTypeDeleteArgs = {
  input: GqlSettingsEcologicalFunctionTypeObservationTypeUnlinkInput;
};


export type MutationSettingsEcologicalFunctionTypeUpdateArgs = {
  input: GqlSettingsEcologicalFunctionTypeUpdateInput;
};


export type MutationSettingsFormTemplateQuestionCreateArgs = {
  input: GqlSettingsFormTemplateQuestionCreateInput;
};


export type MutationSettingsFormTemplateQuestionDeleteArgs = {
  input: GqlSettingsFormTemplateQuestionDeleteInput;
};


export type MutationSettingsFormTemplateQuestionUpdateArgs = {
  input: GqlSettingsFormTemplateQuestionUpdateInput;
};


export type MutationSettingsObservationTypeCreateArgs = {
  input: GqlSettingsObservationTypeCreateInput;
};


export type MutationSettingsObservationTypeDeleteArgs = {
  input: GqlSettingsObservationTypeDeleteInput;
};


export type MutationSettingsObservationTypeEcologicalFunctionTypeCreateArgs = {
  input: GqlSettingsEcologicalFunctionTypeObservationTypeLinkInput;
};


export type MutationSettingsObservationTypeEcologicalFunctionTypeDeleteArgs = {
  input: GqlSettingsEcologicalFunctionTypeObservationTypeUnlinkInput;
};


export type MutationSettingsObservationTypeUpdateArgs = {
  input: GqlSettingsObservationTypeUpdateInput;
};


export type MutationSettingsResearchTypeCreateArgs = {
  input: GqlSettingsResearchTypeCreateInput;
};


export type MutationSettingsResearchTypeDeleteArgs = {
  input: GqlSettingsResearchTypeDeleteInput;
};


export type MutationSettingsResearchTypeSpeciesCreateArgs = {
  input: GqlSettingsResearchTypeSpeciesCreateInput;
};


export type MutationSettingsResearchTypeSpeciesDeleteArgs = {
  input: GqlSettingsResearchTypeSpeciesDeleteInput;
};


export type MutationSettingsResearchTypeSpeciesUpdateShowToClientUserArgs = {
  input: GqlSettingsResearchTypeSpeciesUpdateShowToClientUserInput;
};


export type MutationSettingsResearchTypeUpdateArgs = {
  input: GqlSettingsResearchTypeUpdateInput;
};


export type MutationSettingsSpeciesCreateArgs = {
  input: GqlSettingsSpeciesCreateInput;
};


export type MutationSettingsSpeciesDeleteArgs = {
  input: GqlSettingsSpeciesDeleteInput;
};


export type MutationSettingsSpeciesUpdateArgs = {
  input: GqlSettingsSpeciesUpdateInput;
};


export type MutationSettingsVisitSummaryTemplateUpdateArgs = {
  input: GqlSettingsVisitSummaryTemplateUpdateInput;
};


export type MutationUserCourseDeleteArgs = {
  input: GqlUserDeleteCourseInput;
};


export type MutationUserCreateArgs = {
  input: GqlUserCreateInput;
};


export type MutationUserDeleteArgs = {
  input: GqlUserDeleteInput;
};


export type MutationUserImportStartArgs = {
  input: GqlUserStartImportInput;
};


export type MutationUserLoginArgs = {
  deviceType?: InputMaybe<GqlDeviceType>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationUserRecoverPasswordArgs = {
  input: GqlUserRecoverPasswordInput;
};


export type MutationUserRefreshSessionArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserResetPasswordArgs = {
  input: GqlUserResetPasswordInput;
};


export type MutationUserUpdateArgs = {
  input: GqlUserUpdateInput;
};


export type MutationUserUpdatePushTokenMutationArgs = {
  input: GqlUserUpdateDevicePushTokenInput;
};

export type ObservationCreateInput = {
  answers?: InputMaybe<Scalars['GqlJSON']['input']>;
  createdAt: Scalars['DateTimeISO']['input'];
  feedbackComment?: InputMaybe<Scalars['String']['input']>;
  feedbackRating?: InputMaybe<Scalars['Boolean']['input']>;
  geometry: Scalars['GqlJSON']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  mapEditorLayerId?: InputMaybe<Scalars['String']['input']>;
  mediaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  observationTypeId: Scalars['String']['input'];
  plannerVisitId?: InputMaybe<Scalars['String']['input']>;
  preciseLocation?: InputMaybe<Scalars['GqlJSON']['input']>;
  projectId: Scalars['String']['input'];
  reportId?: InputMaybe<Scalars['String']['input']>;
  researchTypeId: Scalars['String']['input'];
  speciesId: Scalars['String']['input'];
};

export type ObservationFieldResolver_CreatedByUserPayload = {
  __typename: 'ObservationFieldResolver_createdByUserPayload';
  data?: Maybe<GqlUser>;
  error?: Maybe<GqlFieldError>;
};

export type PlannerAreaCreateInput = {
  descriptionClient?: InputMaybe<Scalars['String']['input']>;
  descriptionFieldworker?: InputMaybe<Scalars['String']['input']>;
  descriptionInternal?: InputMaybe<Scalars['String']['input']>;
  geometry: Scalars['GqlJSON']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  mapEditorLayerId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  protocolIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PlannerAreaFieldResolver_MediasClientPayload = {
  __typename: 'PlannerAreaFieldResolver_mediasClientPayload';
  data?: Maybe<Array<GqlMedia>>;
  error?: Maybe<GqlFieldError>;
};

export type PlannerAreaFieldResolver_MediasFieldworkerPayload = {
  __typename: 'PlannerAreaFieldResolver_mediasFieldworkerPayload';
  data?: Maybe<Array<GqlMedia>>;
  error?: Maybe<GqlFieldError>;
};

export type PlannerAreaFieldResolver_MediasInternalPayload = {
  __typename: 'PlannerAreaFieldResolver_mediasInternalPayload';
  data?: Maybe<Array<GqlMedia>>;
  error?: Maybe<GqlFieldError>;
};

export type PlannerVisitFieldResolver_StagedByUserPayload = {
  __typename: 'PlannerVisitFieldResolver_stagedByUserPayload';
  data?: Maybe<GqlUser>;
  error?: Maybe<GqlFieldError>;
};

/** Permissions this user has within the client */
export enum ProjectPermission {
  ProjectViewer = 'PROJECT_VIEWER'
}

export type ProtocolAddProtocolVisitInput = {
  protocolId: Scalars['ID']['input'];
};

export type ProtocolCourseCreateInput = {
  courseId: Scalars['ID']['input'];
  protocolId: Scalars['ID']['input'];
};

export type ProtocolCourseDeleteInput = {
  courseId: Scalars['ID']['input'];
  protocolId: Scalars['ID']['input'];
};

export type ProtocolCreateInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  collectAllMediaPoints: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  requiresRouteShuffling: Scalars['Boolean']['input'];
  researchTypeId: Scalars['String']['input'];
  templateProtocolId?: InputMaybe<Scalars['String']['input']>;
};

export type ProtocolDeleteInput = {
  protocolId: Scalars['ID']['input'];
};

export type ProtocolUpdateInput = {
  collectAllMediaPoints?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  protocolId: Scalars['ID']['input'];
  requiresRouteShuffling?: InputMaybe<Scalars['Boolean']['input']>;
  researchTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type ProtocolUpdateProtocolVisitInput = {
  calculateTravelCost: Scalars['Boolean']['input'];
  condition: Scalars['GqlJSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  maxPrecipitation: Scalars['Float']['input'];
  maxTemperature: Scalars['Float']['input'];
  maxWindForce: Scalars['Float']['input'];
  minDurationInSeconds: Scalars['Int']['input'];
  minTemperature: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerHourInCents: Scalars['Int']['input'];
  protocolVisitId: Scalars['ID']['input'];
  timeslots: Scalars['GqlJSON']['input'];
};

export type ProtocolVisitDeleteInput = {
  protocolVisitId: Scalars['ID']['input'];
};

export type Query = {
  __typename: 'Query';
  addressGetLocation: GqlAddressLocation;
  appConfigGet: GqlAppConfig;
  appDashboardGetComponents: Array<GqlDashboardComponent>;
  appEventBatchGetAll: Array<GqlEventBatch>;
  autocompleteAddresses: Array<GqlAutocompleteResult>;
  autocompleteGetOptions: Array<GqlAutocompleteResult>;
  clientGetAll: GqlClientGetAllPayload;
  clientGetAllRoles: Array<GqlClientRole>;
  clientGetAutocompleteOptions: GqlClientGetAutocompleteOptionsPayload;
  clientUserGetAllAccessibleByUser: GqlClientUserGetAllPayload;
  clientUserGetAllWithAccessToClient: GqlClientUserGetAllPayload;
  commonJobQueueGetJobById: GqlJob;
  courseGetAll: GqlCourseGetAllPayload;
  courseGetById?: Maybe<GqlCourse>;
  courseNameSelectOptions: GqlCourseSelectOptionsPayload;
  ecologicalFunctionObservationGetAllLinkable: Array<GqlObservation>;
  ecologicalFunctionTypeGetAutocompleteOptions: GqlEcologicalFunctionTypeGetAutocompleteOptionsPayload;
  ecologicalFunctionsByVisitGetAll: GqlEcologicalFunctionsByVisitGetAllPayload;
  fieldworkerGetAutocompleteOptions: GqlFieldworkerGetAutocompleteOptionsPayload;
  fieldworkerGetAvailabilityConfig: Array<GqlAvailabilityCategory>;
  fieldworkerGetCalendarDaysEvents: Array<GqlFieldworkerCalendarDayEvents>;
  fieldworkerPaymentGetAll: Array<GqlFieldworkerPayment>;
  fieldworkerPaymentGetById?: Maybe<GqlFieldworkerPayment>;
  invoiceForPeriod?: Maybe<GqlInvoice>;
  invoicePeriods: Array<GqlInvoicePeriod>;
  mapEditorCreateFormOptions: Array<GqlMapEditorCreateFormOption>;
  mapEditorFeatureGetAll: GqlMapEditorFeatureGetAllPayload;
  mapEditorFeatureGetById: GqlMapEditorFeature;
  mapEditorGetAllLayerFeatures: GqlMapEditorLayerAllFeatures;
  mapEditorLayerGetAll: GqlMapEditorLayerGetAllPayload;
  mapEditorLayerGetById: GqlMapEditorLayer;
  mapEditorLayerGetByName?: Maybe<GqlMapEditorLayer>;
  meGetClientInfo: GqlMeClient;
  meGetProjectInfo: GqlMeProject;
  meGetUserInfo: GqlMeUser;
  mediaGetByIds: Array<GqlMedia>;
  notificationGetAll: GqlNotificationGetAllPayload;
  observationEcologicalFunctionGetAllLinkable: Array<GqlEcologicalFunction>;
  observationGetValidationStatus: GqlObservationValidationStatusPayload;
  observationsByVisitGetAll: GqlObservationsByVisitGetAllPayload;
  observationsGetAllForFinalReport: GqlObservationsGetAllForFinalReportPayload;
  plannerAreaGetAutocompleteOptions: GqlPlannerAreaGetAutocompleteOptionsPayload;
  plannerV2AreaGetAllByProjectId: GqlPlannerV2AreaGetAllByProjectIdPayload;
  plannerV2AreaGetById?: Maybe<GqlPlannerV2Area>;
  plannerV2AreasGetInBoundingBox: GqlPlannerV2AreasGetInBoundingBoxPayload;
  plannerV2AreasGetWithPendingChanges: GqlPlannerV2ReviewSchedulePayload;
  plannerV2FieldworkerGetTravelDistanceFromVisit: GqlPlannerV2FieldworkerStraightTravelDistance;
  plannerV2FieldworkersGetPlannableForVisit: Array<GqlFieldworker>;
  plannerV2MapElementsGetByPlannerTravelGroupId: GqlPlannerV2MapElementsPayload;
  plannerV2MapElementsGetByPlannerVisitId: GqlPlannerV2MapElementsPayload;
  plannerV2MaxRequiredFieldworkersGetInBoundingBox?: Maybe<Scalars['Int']['output']>;
  plannerV2ShiftGetAll: GqlPlannerV2ShiftsGetAll;
  plannerV2ShiftGetById?: Maybe<GqlPlannerV2Shift>;
  plannerV2ShiftsGetPendingForMe: Array<GqlPlannerV2Shift>;
  plannerV2TravelGroupGetAdditionalVisits: Array<GqlPlannerV2TravelGroupGetAdditionalVisitsPayload>;
  plannerV2TravelGroupGetTimeline: GqlPlannerV2TravelGroupTimelinePayload;
  plannerV2TravelGroupsGetAttendingVisit: Array<GqlPlannerV2TravelGroupAttendance>;
  plannerV2VisitGetAll: GqlPlannerV2VisitGetAllPayload;
  plannerV2VisitGetById?: Maybe<GqlPlannerV2Visit>;
  plannerV2VisitGetPlannedOnDates: Array<GqlPlannerV2VisitPlannedOnDate>;
  plannerV2VisitGetPossibleTimes: Array<GqlPlannerV2PossibleTime>;
  plannerVisitGetAllMapEditorLayerFeatures?: Maybe<GqlMapEditorLayerAllFeatures>;
  plannerVisitHasAllObservationsApproved: Scalars['Boolean']['output'];
  plannerVisitHasAllPossibleFunctionsHandled: Scalars['Boolean']['output'];
  plannerVisitHasAllReportsApproved: Scalars['Boolean']['output'];
  plannerVisitHasAllTimeRangesValid?: Maybe<Scalars['Boolean']['output']>;
  plannerVisitHasAllWeatherConditionsValid: Scalars['Boolean']['output'];
  plannerVisitPossibleFunctions: GqlPlannerVisitPossibleFunctionObservationsPayload;
  plannerVisitWeatherReportGetByVisitId?: Maybe<GqlPlannerVisitWeatherReport>;
  plannerVisitWorkerReportById?: Maybe<GqlPlannerVisitV2WorkerReport>;
  plannerVisitWorkerReportGetAll: Array<GqlPlannerVisitV2WorkerReport>;
  projectCostGetAllForProject: GqlProjectCostGetAll;
  projectExportGetAll?: Maybe<GqlProjectExportGetAllPayload>;
  projectGetAll: GqlProjectGetAllPayload;
  projectGetAllRoles: Array<GqlProjectRole>;
  projectGetAutocompleteOptions: GqlProjectGetAutocompleteOptionsPayload;
  projectGetById?: Maybe<GqlProject>;
  projectGetDeliverablesMap: Array<GqlDeliverableMap>;
  projectGetDeliverablesTables: Array<GqlDeliverableTable>;
  projectGetFunctionTypesById: Array<GqlProjectFunctionTypeFilter>;
  projectGetObservationTypesById: Array<GqlProjectObservationTypeFilter>;
  projectGetResearchTypesById: Array<GqlProjectResearchTypeFilter>;
  projectStatisticsGetById: GqlProjectStatistics;
  projectUserGetAllAccessibleByUser: GqlProjectUserGetAllPayload;
  projectUserGetAllWithAccessToProject: GqlProjectUserGetAllPayload;
  protocolGetAll: GqlProtocolGetAll;
  protocolGetById?: Maybe<GqlProtocol>;
  settingsEcologicalFunctionTypeGetAllAssignable: Array<GqlSettingsEcologicalFunctionType>;
  settingsEcologicalFunctionTypeGetById: GqlSettingsEcologicalFunctionType;
  settingsFormTemplateGetMasterForm: GqlSettingsFormTemplate;
  settingsFormTemplateQuestionGetById: GqlSettingsFormTemplateQuestion;
  settingsObservationTypeGetAllAssignable: Array<GqlSettingsObservationType>;
  settingsObservationTypeGetById: GqlSettingsObservationType;
  settingsResearchTypeGetAll: SettingsResearchTypeGetAllPayload;
  settingsResearchTypeGetAutocompleteOptions: GqlSettingsResearchTypeGetAutocompleteOptionsPayload;
  settingsResearchTypeGetById: GqlSettingsResearchType;
  settingsSpeciesGetAll: SettingsSpeciesGetAllPayload;
  settingsSpeciesGetById: GqlSettingsSpecies;
  settingsSpeciesGetByIds: Array<GqlSettingsSpecies>;
  speciesGetAutocompleteOptions: GqlSpeciesGetAutocompleteOptionsPayload;
  userGetAll: GqlUserGetAll;
  userGetById?: Maybe<GqlUser>;
};


export type QueryAddressGetLocationArgs = {
  addressId: Scalars['String']['input'];
};


export type QueryAppEventBatchGetAllArgs = {
  batchIds: Array<Scalars['String']['input']>;
};


export type QueryAutocompleteAddressesArgs = {
  search: Scalars['String']['input'];
};


export type QueryAutocompleteGetOptionsArgs = {
  model: AutocompleteModel;
  params?: InputMaybe<Scalars['GqlJSON']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryClientGetAllArgs = {
  params?: InputMaybe<GqlClientGetAllParams>;
};


export type QueryClientGetAutocompleteOptionsArgs = {
  params: GqlClientGetAutocompleteOptionsParams;
};


export type QueryClientUserGetAllAccessibleByUserArgs = {
  params?: InputMaybe<GqlClientUserGetAllClientsParams>;
  userId: Scalars['ID']['input'];
};


export type QueryClientUserGetAllWithAccessToClientArgs = {
  params: GqlClientUserGetAllUsersParams;
};


export type QueryCommonJobQueueGetJobByIdArgs = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QueryCourseGetAllArgs = {
  params?: InputMaybe<GqlCourseGetAllParams>;
};


export type QueryCourseGetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEcologicalFunctionObservationGetAllLinkableArgs = {
  featureId: Scalars['ID']['input'];
};


export type QueryEcologicalFunctionTypeGetAutocompleteOptionsArgs = {
  params: GqlEcologicalFunctionTypeGetAutocompleteOptionsParams;
};


export type QueryEcologicalFunctionsByVisitGetAllArgs = {
  params: GqlEcologicalFunctionSearchParams;
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryFieldworkerGetAutocompleteOptionsArgs = {
  params: GqlFieldworkerGetAutocompleteOptionsParams;
};


export type QueryFieldworkerGetCalendarDaysEventsArgs = {
  endAt: Scalars['DateTimeISO']['input'];
  startAt: Scalars['DateTimeISO']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryFieldworkerPaymentGetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoiceForPeriodArgs = {
  clientId: Scalars['String']['input'];
  invoiceId: Scalars['ID']['input'];
};


export type QueryInvoicePeriodsArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryMapEditorFeatureGetAllArgs = {
  params?: InputMaybe<GqlMapEditorFeatureSearchParams>;
};


export type QueryMapEditorFeatureGetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMapEditorGetAllLayerFeaturesArgs = {
  params: GqlMapEditorGetLayerAllFeaturesParams;
  projectId: Scalars['ID']['input'];
};


export type QueryMapEditorLayerGetAllArgs = {
  params: GqlMapEditorLayerGetAllParams;
};


export type QueryMapEditorLayerGetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMapEditorLayerGetByNameArgs = {
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryMeGetClientInfoArgs = {
  clientSlug: Scalars['String']['input'];
};


export type QueryMeGetProjectInfoArgs = {
  projectSlug: Scalars['String']['input'];
};


export type QueryMediaGetByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryNotificationGetAllArgs = {
  params?: InputMaybe<GqlNotificationGetAllParams>;
};


export type QueryObservationEcologicalFunctionGetAllLinkableArgs = {
  featureId: Scalars['ID']['input'];
};


export type QueryObservationGetValidationStatusArgs = {
  observationId: Scalars['ID']['input'];
};


export type QueryObservationsByVisitGetAllArgs = {
  params: GqlObservationsByVisitSearchParams;
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryObservationsGetAllForFinalReportArgs = {
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerAreaGetAutocompleteOptionsArgs = {
  params: GqlPlannerAreaGetAutocompleteOptionsParams;
};


export type QueryPlannerV2AreaGetAllByProjectIdArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryPlannerV2AreaGetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlannerV2AreasGetInBoundingBoxArgs = {
  boundingBox: Array<Scalars['Float']['input']>;
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxRequiredFieldworkers?: InputMaybe<Scalars['Int']['input']>;
  onDate: Scalars['DateTimeISO']['input'];
  plannedFieldworkerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  plannerAreaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  plannerStatusBucket?: InputMaybe<Array<Scalars['String']['input']>>;
  projectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  researchTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPlannerV2FieldworkerGetTravelDistanceFromVisitArgs = {
  fieldworkerId: Scalars['ID']['input'];
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerV2FieldworkersGetPlannableForVisitArgs = {
  fieldworkerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
  onDate: Scalars['DateTimeISO']['input'];
  plannerVisitId: Scalars['ID']['input'];
  timeslotId: Scalars['String']['input'];
  transportationMethods?: InputMaybe<Array<GqlFieldworkerPreferredTransportationMethod>>;
};


export type QueryPlannerV2MapElementsGetByPlannerTravelGroupIdArgs = {
  plannerTravelGroupId: Scalars['ID']['input'];
};


export type QueryPlannerV2MapElementsGetByPlannerVisitIdArgs = {
  onDate: Scalars['DateTimeISO']['input'];
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerV2MaxRequiredFieldworkersGetInBoundingBoxArgs = {
  boundingBox: Array<Scalars['Float']['input']>;
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  onDate: Scalars['DateTimeISO']['input'];
  plannedFieldworkerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  plannerAreaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  projectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  researchTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPlannerV2ShiftGetAllArgs = {
  params: GqlPlannerV2ShiftsGetAllArgs;
};


export type QueryPlannerV2ShiftGetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlannerV2TravelGroupGetAdditionalVisitsArgs = {
  plannerTravelGroupId: Scalars['ID']['input'];
};


export type QueryPlannerV2TravelGroupGetTimelineArgs = {
  plannerTravelGroupId: Scalars['ID']['input'];
};


export type QueryPlannerV2TravelGroupsGetAttendingVisitArgs = {
  onDate: Scalars['DateTimeISO']['input'];
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerV2VisitGetAllArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  params?: InputMaybe<GqlPlannerV2VisitGetAllParams>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlannerV2VisitGetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlannerV2VisitGetPlannedOnDatesArgs = {
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerV2VisitGetPossibleTimesArgs = {
  id: Scalars['ID']['input'];
  onDate: Scalars['DateTimeISO']['input'];
};


export type QueryPlannerVisitGetAllMapEditorLayerFeaturesArgs = {
  params: GqlMapEditorGetLayerAllFeaturesParams;
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerVisitHasAllObservationsApprovedArgs = {
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerVisitHasAllPossibleFunctionsHandledArgs = {
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerVisitHasAllReportsApprovedArgs = {
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerVisitHasAllTimeRangesValidArgs = {
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerVisitHasAllWeatherConditionsValidArgs = {
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerVisitPossibleFunctionsArgs = {
  params: GqlPlannerVisitPossibleFunctionObservationsSearchParams;
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerVisitWeatherReportGetByVisitIdArgs = {
  plannerVisitId: Scalars['ID']['input'];
};


export type QueryPlannerVisitWorkerReportByIdArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryPlannerVisitWorkerReportGetAllArgs = {
  filters: GqlPlannerVisitWorkerReportFilters;
};


export type QueryProjectCostGetAllForProjectArgs = {
  params?: InputMaybe<GqlProjectCostGetAllParams>;
  projectId: Scalars['ID']['input'];
};


export type QueryProjectExportGetAllArgs = {
  clientId: Scalars['ID']['input'];
  params?: InputMaybe<GqlProjectExportGetAllParams>;
};


export type QueryProjectGetAllArgs = {
  params: GqlProjectGetAllParams;
};


export type QueryProjectGetAutocompleteOptionsArgs = {
  params: GqlProjectGetAutocompleteOptionsParams;
};


export type QueryProjectGetByIdArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectGetDeliverablesMapArgs = {
  plannerAreaIds: Array<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  researchTypeId: Scalars['ID']['input'];
};


export type QueryProjectGetDeliverablesTablesArgs = {
  plannerAreaIds: Array<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  researchTypeId: Scalars['ID']['input'];
};


export type QueryProjectGetFunctionTypesByIdArgs = {
  plannerVisitId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryProjectGetObservationTypesByIdArgs = {
  plannerVisitId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryProjectGetResearchTypesByIdArgs = {
  plannerVisitId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryProjectStatisticsGetByIdArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectUserGetAllAccessibleByUserArgs = {
  params?: InputMaybe<GqlProjectUserGetAllProjectsParams>;
  userId: Scalars['ID']['input'];
};


export type QueryProjectUserGetAllWithAccessToProjectArgs = {
  params: GqlProjectUserGetAllUsersParams;
};


export type QueryProtocolGetAllArgs = {
  params?: InputMaybe<GqlProtocolGetAllParams>;
};


export type QueryProtocolGetByIdArgs = {
  protocolId: Scalars['ID']['input'];
};


export type QuerySettingsEcologicalFunctionTypeGetAllAssignableArgs = {
  params: GqlSettingsEcologicalFunctionTypeGetAllAssignableParams;
};


export type QuerySettingsEcologicalFunctionTypeGetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySettingsFormTemplateGetMasterFormArgs = {
  type: GqlSettingsFormTemplateMasterFormType;
};


export type QuerySettingsFormTemplateQuestionGetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySettingsObservationTypeGetAllAssignableArgs = {
  params: GqlSettingsObservationTypeGetAllAssignableParams;
};


export type QuerySettingsObservationTypeGetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySettingsResearchTypeGetAllArgs = {
  params?: InputMaybe<GqlSettingsResearchTypeGetAllParams>;
};


export type QuerySettingsResearchTypeGetAutocompleteOptionsArgs = {
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QuerySettingsResearchTypeGetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySettingsSpeciesGetAllArgs = {
  params?: InputMaybe<GqlSettingsSpeciesGetAllParams>;
};


export type QuerySettingsSpeciesGetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySettingsSpeciesGetByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QuerySpeciesGetAutocompleteOptionsArgs = {
  params: GqlSpeciesGetAutocompleteOptionsParams;
};


export type QueryUserGetAllArgs = {
  params?: InputMaybe<GqlUserGetAllParams>;
};


export type QueryUserGetByIdArgs = {
  id: Scalars['ID']['input'];
};

export type SelectOption = {
  __typename: 'SelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SettingsResearchTypeGetAllPayload = {
  __typename: 'SettingsResearchTypeGetAllPayload';
  data: Array<GqlSettingsResearchType>;
  queryInfo: GqlQueryInfo;
};

export type SettingsSpeciesGetAllPayload = {
  __typename: 'SettingsSpeciesGetAllPayload';
  data: Array<GqlSettingsSpecies>;
  queryInfo: GqlQueryInfo;
};
